/* As per request from Estani: The templates are WITHIN this file. They cannot be found on the filesystem! */
/* Happy scrolling :D */

angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dialog","ui.bootstrap.dropdownToggle","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/popup.html","template/dialog/message.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset-titles.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.transition', [])

/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */
    .factory('$transition', ['$q', '$timeout', '$rootScope', function($q, $timeout, $rootScope) {

        var $transition = function(element, trigger, options) {
            options = options || {};
            var deferred = $q.defer();
            var endEventName = $transition[options.animation ? "animationEndEventName" : "transitionEndEventName"];

            var transitionEndHandler = function(event) {
                $rootScope.$apply(function() {
                    element.unbind(endEventName, transitionEndHandler);
                    deferred.resolve(element);
                });
            };

            if (endEventName) {
                element.bind(endEventName, transitionEndHandler);
            }

            // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
            $timeout(function() {
                if ( angular.isString(trigger) ) {
                    element.addClass(trigger);
                } else if ( angular.isFunction(trigger) ) {
                    trigger(element);
                } else if ( angular.isObject(trigger) ) {
                    element.css(trigger);
                }
                //If browser does not support transitions, instantly resolve
                if ( !endEventName ) {
                    deferred.resolve(element);
                }
            });

            // Add our custom cancel function to the promise that is returned
            // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
            // i.e. it will therefore never raise a transitionEnd event for that transition
            deferred.promise.cancel = function() {
                if ( endEventName ) {
                    element.unbind(endEventName, transitionEndHandler);
                }
                deferred.reject('Transition cancelled');
            };

            return deferred.promise;
        };

        // Work out the name of the transitionEnd event
        var transElement = document.createElement('trans');
        var transitionEndEventNames = {
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'transition': 'transitionend'
        };
        var animationEndEventNames = {
            'WebkitTransition': 'webkitAnimationEnd',
            'MozTransition': 'animationend',
            'OTransition': 'oAnimationEnd',
            'transition': 'animationend'
        };
        function findEndEventName(endEventNames) {
            for (var name in endEventNames){
                if (transElement.style[name] !== undefined) {
                    return endEventNames[name];
                }
            }
        }
        $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
        $transition.animationEndEventName = findEndEventName(animationEndEventNames);
        return $transition;
    }]);

angular.module('ui.bootstrap.collapse',['ui.bootstrap.transition'])

// The collapsible directive indicates a block of html that will expand and collapse
    .directive('collapse', ['$transition', function($transition) {
        // CSS transitions don't work with height: auto, so we have to manually change the height to a
        // specific value and then once the animation completes, we can reset the height to auto.
        // Unfortunately if you do this while the CSS transitions are specified (i.e. in the CSS class
        // "collapse") then you trigger a change to height 0 in between.
        // The fix is to remove the "collapse" CSS class while changing the height back to auto - phew!
        var fixUpHeight = function(scope, element, height) {
            // We remove the collapse CSS class to prevent a transition when we change to height: auto
            element.removeClass('collapse');
            element.css({ height: height });
            // It appears that  reading offsetWidth makes the browser realise that we have changed the
            // height already :-/
            var x = element[0].offsetWidth;
            element.addClass('collapse');
        };

        return {
            link: function(scope, element, attrs) {

                var isCollapsed;
                var initialAnimSkip = true;
                scope.$watch(function (){ return element[0].scrollHeight; }, function (value) {
                    //The listener is called when scollHeight changes
                    //It actually does on 2 scenarios:
                    // 1. Parent is set to display none
                    // 2. angular bindings inside are resolved
                    //When we have a change of scrollHeight we are setting again the correct height if the group is opened
                    if (element[0].scrollHeight !== 0) {
                        if (!isCollapsed) {
                            if (initialAnimSkip) {
                                fixUpHeight(scope, element, element[0].scrollHeight + 'px');
                            } else {
                                fixUpHeight(scope, element, 'auto');
                            }
                        }
                    }
                });

                scope.$watch(attrs.collapse, function(value) {
                    if (value) {
                        collapse();
                    } else {
                        expand();
                    }
                });


                var currentTransition;
                var doTransition = function(change) {
                    if ( currentTransition ) {
                        currentTransition.cancel();
                    }
                    currentTransition = $transition(element,change);
                    currentTransition.then(
                        function() { currentTransition = undefined; },
                        function() { currentTransition = undefined; }
                    );
                    return currentTransition;
                };

                var expand = function() {
                    if (initialAnimSkip) {
                        initialAnimSkip = false;
                        if ( !isCollapsed ) {
                            fixUpHeight(scope, element, 'auto');
                        }
                    } else {
                        doTransition({ height : element[0].scrollHeight + 'px' })
                            .then(function() {
                                // This check ensures that we don't accidentally update the height if the user has closed
                                // the group while the animation was still running
                                if ( !isCollapsed ) {
                                    fixUpHeight(scope, element, 'auto');
                                }
                            });
                    }
                    isCollapsed = false;
                };

                var collapse = function() {
                    isCollapsed = true;
                    if (initialAnimSkip) {
                        initialAnimSkip = false;
                        fixUpHeight(scope, element, 0);
                    } else {
                        fixUpHeight(scope, element, element[0].scrollHeight + 'px');
                        doTransition({'height':'0'});
                    }
                };
            }
        };
    }]);

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

    .constant('accordionConfig', {
        closeOthers: true
    })

    .controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function ($scope, $attrs, accordionConfig) {

        // This array keeps track of the accordion groups
        this.groups = [];

        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
        this.closeOthers = function(openGroup) {
            var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
            if (closeOthers) {
                angular.forEach(this.groups, function (group) {
                    if (group !== openGroup && group.closeOthers) {
                        group.isOpen = false;
                    }
                });
            }
        };

        // This is called from the accordion-group directive to add itself to the accordion
        this.addGroup = function(groupScope) {
            var that = this;
            this.groups.push(groupScope);

            groupScope.$on('$destroy', function (event) {
                that.removeGroup(groupScope);
            });
        };

        // This is called from the accordion-group directive when to remove itself
        this.removeGroup = function(group) {
            var index = this.groups.indexOf(group);
            if ( index !== -1 ) {
                this.groups.splice(this.groups.indexOf(group), 1);
            }
        };

    }])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
    .directive('accordion', function () {
        return {
            restrict:'EA',
            controller:'AccordionController',
            transclude: true,
            replace: false,
            templateUrl: 'template/accordion/accordion.html'
        };
    })

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
    .directive('accordionGroup', ['$parse', '$transition', '$timeout', function($parse, $transition, $timeout) {
        return {
            require:'^accordion',         // We need this directive to be inside an accordion
            restrict:'EA',
            transclude:true,              // It transcludes the contents of the directive into the template
            replace: true,                // The element containing the directive will be replaced with the template
            templateUrl:'template/accordion/accordion-group.html',
            scope:{
            	heading:'@',
            	closeOthers: '@'
        	},        // Create an isolated scope and interpolate the heading attribute onto this scope
            controller: ['$scope', function($scope) {
                this.setHeading = function(element) {
                    this.heading = element;
                };
            }],
            link: function(scope, element, attrs, accordionCtrl) {
                var getIsOpen, setIsOpen;

                accordionCtrl.addGroup(scope);

                scope.isOpen = false;

                if ( attrs.isOpen ) {
                    getIsOpen = $parse(attrs.isOpen);
                    setIsOpen = getIsOpen.assign;

                    scope.$watch(
                        function watchIsOpen() { return getIsOpen(scope.$parent); },
                        function updateOpen(value) { scope.isOpen = value; }
                    );

                    scope.isOpen = getIsOpen ? getIsOpen(scope.$parent) : false;
                }

                scope.$watch('isOpen', function(value) {
                    if ( value ) {
                        accordionCtrl.closeOthers(scope);
                    }
                    if ( setIsOpen ) {
                        setIsOpen(scope.$parent, value);
                    }
                });
            }
        };
    }])

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
    .directive('accordionHeading', function() {
        return {
            restrict: 'EA',
            transclude: true,   // Grab the contents to be used as the heading
            template: '',       // In effect remove this element!
            replace: true,
            require: '^accordionGroup',
            compile: function(element, attr, transclude) {
                return function link(scope, element, attr, accordionGroupCtrl) {
                    // Pass the heading to the accordion-group controller
                    // so that it can be transcluded into the right place in the template
                    // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                    accordionGroupCtrl.setHeading(transclude(scope, function() {}));
                };
            }
        };
    })

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
    .directive('accordionTransclude', function() {
        return {
            require: '^accordionGroup',
            link: function(scope, element, attr, controller) {
                scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
                    if ( heading ) {
                        element.html('');
                        element.append(heading);
                    }
                });
            }
        };
    });

angular.module("ui.bootstrap.alert", []).directive('alert', function () {
    return {
        restrict:'EA',
        templateUrl:'template/alert/alert.html',
        transclude:true,
        replace:true,
        scope: {
            type: '=',
            close: '&'
        },
        link: function(scope, iElement, iAttrs, controller) {
            scope.closeable = "close" in iAttrs;
        }
    };
});

angular.module('ui.bootstrap.buttons', [])

    .constant('buttonConfig', {
        activeClass:'active',
        toggleEvent:'click'
    })

    .directive('btnRadio', ['buttonConfig', function (buttonConfig) {
        var activeClass = buttonConfig.activeClass || 'active';
        var toggleEvent = buttonConfig.toggleEvent || 'click';

        return {

            require:'ngModel',
            link:function (scope, element, attrs, ngModelCtrl) {

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
                };

                //ui->model
                element.bind(toggleEvent, function () {
                    if (!element.hasClass(activeClass)) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(scope.$eval(attrs.btnRadio));
                            ngModelCtrl.$render();
                        });
                    }
                });
            }
        };
    }])

    .directive('btnCheckbox', ['buttonConfig', function (buttonConfig) {

        var activeClass = buttonConfig.activeClass || 'active';
        var toggleEvent = buttonConfig.toggleEvent || 'click';

        return {
            require:'ngModel',
            link:function (scope, element, attrs, ngModelCtrl) {

                function getTrueValue() {
                    var trueValue = scope.$eval(attrs.btnCheckboxTrue);
                    return angular.isDefined(trueValue) ? trueValue : true;
                }

                function getFalseValue() {
                    var falseValue = scope.$eval(attrs.btnCheckboxFalse);
                    return angular.isDefined(falseValue) ? falseValue : false;
                }

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                };

                //ui->model
                element.bind(toggleEvent, function () {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.hasClass(activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    }]);
/**
 * @ngdoc overview
 * @name ui.bootstrap.carousel
 *
 * @description
 * AngularJS version of an image carousel.
 *
 */
angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition'])
    .controller('CarouselController', ['$scope', '$timeout', '$transition', '$q', function ($scope, $timeout, $transition, $q) {
        var self = this,
            slides = self.slides = [],
            currentIndex = -1,
            currentTimeout, isPlaying;
        self.currentSlide = null;

        /* direction: "prev" or "next" */
        self.select = function(nextSlide, direction) {
            var nextIndex = slides.indexOf(nextSlide);
            //Decide direction if it's not given
            if (direction === undefined) {
                direction = nextIndex > currentIndex ? "next" : "prev";
            }
            if (nextSlide && nextSlide !== self.currentSlide) {
                if ($scope.$currentTransition) {
                    $scope.$currentTransition.cancel();
                    //Timeout so ng-class in template has time to fix classes for finished slide
                    $timeout(goNext);
                } else {
                    goNext();
                }
            }
            function goNext() {
                //If we have a slide to transition from and we have a transition type and we're allowed, go
                if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
                    //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
                    nextSlide.$element.addClass(direction);
                    nextSlide.$element[0].offsetWidth = nextSlide.$element[0].offsetWidth; //force reflow

                    //Set all other slides to stop doing their stuff for the new transition
                    angular.forEach(slides, function(slide) {
                        angular.extend(slide, {direction: '', entering: false, leaving: false, active: false});
                    });
                    angular.extend(nextSlide, {direction: direction, active: true, entering: true});
                    angular.extend(self.currentSlide||{}, {direction: direction, leaving: true});

                    $scope.$currentTransition = $transition(nextSlide.$element, {});
                    //We have to create new pointers inside a closure since next & current will change
                    (function(next,current) {
                        $scope.$currentTransition.then(
                            function(){ transitionDone(next, current); },
                            function(){ transitionDone(next, current); }
                        );
                    }(nextSlide, self.currentSlide));
                } else {
                    transitionDone(nextSlide, self.currentSlide);
                }
                self.currentSlide = nextSlide;
                currentIndex = nextIndex;
                //every time you change slides, reset the timer
                restartTimer();
            }
            function transitionDone(next, current) {
                angular.extend(next, {direction: '', active: true, leaving: false, entering: false});
                angular.extend(current||{}, {direction: '', active: false, leaving: false, entering: false});
                $scope.$currentTransition = null;
            }
        };

        /* Allow outside people to call indexOf on slides array */
        self.indexOfSlide = function(slide) {
            return slides.indexOf(slide);
        };

        $scope.next = function() {
            var newIndex = (currentIndex + 1) % slides.length;

            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (!$scope.$currentTransition) {
                return self.select(slides[newIndex], 'next');
            }
        };

        $scope.prev = function() {
            var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;

            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (!$scope.$currentTransition) {
                return self.select(slides[newIndex], 'prev');
            }
        };

        $scope.select = function(slide) {
            self.select(slide);
        };

        $scope.isActive = function(slide) {
            return self.currentSlide === slide;
        };

        $scope.slides = function() {
            return slides;
        };

        $scope.$watch('interval', restartTimer);
        function restartTimer() {
            if (currentTimeout) {
                $timeout.cancel(currentTimeout);
            }
            function go() {
                if (isPlaying) {
                    $scope.next();
                    restartTimer();
                } else {
                    $scope.pause();
                }
            }
            var interval = +$scope.interval;
            if (!isNaN(interval) && interval>=0) {
                currentTimeout = $timeout(go, interval);
            }
        }
        $scope.play = function() {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };
        $scope.pause = function() {
            if (!$scope.noPause) {
                isPlaying = false;
                if (currentTimeout) {
                    $timeout.cancel(currentTimeout);
                }
            }
        };

        self.addSlide = function(slide, element) {
            slide.$element = element;
            slides.push(slide);
            //if this is the first slide or the slide is set to active, select it
            if(slides.length === 1 || slide.active) {
                self.select(slides[slides.length-1]);
                if (slides.length == 1) {
                    $scope.play();
                }
            } else {
                slide.active = false;
            }
        };

        self.removeSlide = function(slide) {
            //get the index of the slide inside the carousel
            var index = slides.indexOf(slide);
            slides.splice(index, 1);
            if (slides.length > 0 && slide.active) {
                if (index >= slides.length) {
                    self.select(slides[index-1]);
                } else {
                    self.select(slides[index]);
                }
            } else if (currentIndex > index) {
                currentIndex--;
            }
        };
    }])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
 <example module="ui.bootstrap">
 <file name="index.html">
 <carousel>
 <slide>
 <img src="http://placekitten.com/150/150" style="margin:auto;">
 <div class="carousel-caption">
 <p>Beautiful!</p>
 </div>
 </slide>
 <slide>
 <img src="http://placekitten.com/100/150" style="margin:auto;">
 <div class="carousel-caption">
 <p>D'aww!</p>
 </div>
 </slide>
 </carousel>
 </file>
 <file name="demo.css">
 .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
 </file>
 </example>
 */
    .directive('carousel', [function() {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            controller: 'CarouselController',
            require: 'carousel',
            templateUrl: 'template/carousel/carousel.html',
            scope: {
                interval: '=',
                noTransition: '=',
                noPause: '='
            }
        };
    }])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 *
 * @example
 <example module="ui.bootstrap">
 <file name="index.html">
 <div ng-controller="CarouselDemoCtrl">
 <carousel>
 <slide ng-repeat="slide in slides" active="slide.active">
 <img ng-src="{{slide.image}}" style="margin:auto;">
 <div class="carousel-caption">
 <h4>Slide {{$index}}</h4>
 <p>{{slide.text}}</p>
 </div>
 </slide>
 </carousel>
 <div class="row-fluid">
 <div class="span6">
 <ul>
 <li ng-repeat="slide in slides">
 <button class="btn btn-mini" ng-class="{'btn-info': !slide.active, 'btn-success': slide.active}" ng-disabled="slide.active" ng-click="slide.active = true">select</button>
 {{$index}}: {{slide.text}}
 </li>
 </ul>
 <a class="btn" ng-click="addSlide()">Add Slide</a>
 </div>
 <div class="span6">
 Interval, in milliseconds: <input type="number" ng-model="myInterval">
 <br />Enter a negative number to stop the interval.
 </div>
 </div>
 </div>
 </file>
 <file name="script.js">
 function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
  var slides = $scope.slides = [];
  $scope.addSlide = function() {
    var newWidth = 200 + ((slides.length + (25 * slides.length)) % 150);
    slides.push({
      image: 'http://placekitten.com/' + newWidth + '/200',
      text: ['More','Extra','Lots of','Surplus'][slides.length % 4] + ' '
        ['Cats', 'Kittys', 'Felines', 'Cutes'][slides.length % 4]
    });
  };
  for (var i=0; i<4; i++) $scope.addSlide();
}
 </file>
 <file name="demo.css">
 .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
 </file>
 </example>
 */

    .directive('slide', ['$parse', function($parse) {
        return {
            require: '^carousel',
            restrict: 'EA',
            transclude: true,
            replace: true,
            templateUrl: 'template/carousel/slide.html',
            scope: {
            },
            link: function (scope, element, attrs, carouselCtrl) {
                //Set up optional 'active' = binding
                if (attrs.active) {
                    var getActive = $parse(attrs.active);
                    var setActive = getActive.assign;
                    var lastValue = scope.active = getActive(scope.$parent);
                    scope.$watch(function parentActiveWatch() {
                        var parentActive = getActive(scope.$parent);

                        if (parentActive !== scope.active) {
                            // we are out of sync and need to copy
                            if (parentActive !== lastValue) {
                                // parent changed and it has precedence
                                lastValue = scope.active = parentActive;
                            } else {
                                // if the parent can be assigned then do so
                                setActive(scope.$parent, parentActive = lastValue = scope.active);
                            }
                        }
                        return parentActive;
                    });
                }

                carouselCtrl.addSlide(scope, element);
                //when the scope is destroyed then remove the slide from the current slides array
                scope.$on('$destroy', function() {
                    carouselCtrl.removeSlide(scope);
                });

                scope.$watch('active', function(active) {
                    if (active) {
                        carouselCtrl.select(scope);
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
    .factory('$position', ['$document', '$window', function ($document, $window) {

        var mouseX, mouseY;

        $document.bind('mousemove', function mouseMoved(event) {
            mouseX = event.pageX;
            mouseY = event.pageY;
        });

        function getStyle(el, cssprop) {
            if (el.currentStyle) { //IE
                return el.currentStyle[cssprop];
            } else if ($window.getComputedStyle) {
                return $window.getComputedStyle(el)[cssprop];
            }
            // finally try and get inline style
            return el.style[cssprop];
        }

        /**
         * Checks if a given element is statically positioned
         * @param element - raw DOM element
         */
        function isStaticPositioned(element) {
            return (getStyle(element, "position") || 'static' ) === 'static';
        }

        /**
         * returns the closest, non-statically positioned parentOffset of a given element
         * @param element
         */
        var parentOffsetEl = function (element) {
            var docDomEl = $document[0];
            var offsetParent = element.offsetParent || docDomEl;
            while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
                offsetParent = offsetParent.offsetParent;
            }
            return offsetParent || docDomEl;
        };

        return {
            /**
             * Provides read-only equivalent of jQuery's position function:
             * http://api.jquery.com/position/
             */
            position: function (element) {
                var elBCR = this.offset(element);
                var offsetParentBCR = { top: 0, left: 0 };
                var offsetParentEl = parentOffsetEl(element[0]);
                if (offsetParentEl != $document[0]) {
                    offsetParentBCR = this.offset(angular.element(offsetParentEl));
                    offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
                    offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
                }

                return {
                    width: element.prop('offsetWidth'),
                    height: element.prop('offsetHeight'),
                    top: elBCR.top - offsetParentBCR.top,
                    left: elBCR.left - offsetParentBCR.left
                };
            },

            /**
             * Provides read-only equivalent of jQuery's offset function:
             * http://api.jquery.com/offset/
             */
            offset: function (element) {
                var boundingClientRect = element[0].getBoundingClientRect();
                return {
                    width: element.prop('offsetWidth'),
                    height: element.prop('offsetHeight'),
                    top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop),
                    left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft)
                };
            },

            /**
             * Provides the coordinates of the mouse
             */
            mouse: function () {
                return {x: mouseX, y: mouseY};
            }
        };
    }]);

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.position'])

    .constant('datepickerConfig', {
        dayFormat: 'dd',
        monthFormat: 'MMMM',
        yearFormat: 'yyyy',
        dayHeaderFormat: 'EEE',
        dayTitleFormat: 'MMMM yyyy',
        monthTitleFormat: 'yyyy',
        showWeeks: true,
        startingDay: 0,
        yearRange: 20,
        minDate: null,
        maxDate: null
    })

    .controller('DatepickerController', ['$scope', '$attrs', 'dateFilter', 'datepickerConfig', function($scope, $attrs, dateFilter, dtConfig) {
        var format = {
                day:        getValue($attrs.dayFormat,        dtConfig.dayFormat),
                month:      getValue($attrs.monthFormat,      dtConfig.monthFormat),
                year:       getValue($attrs.yearFormat,       dtConfig.yearFormat),
                dayHeader:  getValue($attrs.dayHeaderFormat,  dtConfig.dayHeaderFormat),
                dayTitle:   getValue($attrs.dayTitleFormat,   dtConfig.dayTitleFormat),
                monthTitle: getValue($attrs.monthTitleFormat, dtConfig.monthTitleFormat)
            },
            startingDay = getValue($attrs.startingDay,      dtConfig.startingDay),
            yearRange =   getValue($attrs.yearRange,        dtConfig.yearRange);

        this.minDate = dtConfig.minDate ? new Date(dtConfig.minDate) : null;
        this.maxDate = dtConfig.maxDate ? new Date(dtConfig.maxDate) : null;

        function getValue(value, defaultValue) {
            return angular.isDefined(value) ? $scope.$parent.$eval(value) : defaultValue;
        }

        function getDaysInMonth( year, month ) {
            return new Date(year, month, 0).getDate();
        }

        function getDates(startDate, n) {
            var dates = new Array(n);
            var current = startDate, i = 0;
            while (i < n) {
                dates[i++] = new Date(current);
                current.setDate( current.getDate() + 1 );
            }
            return dates;
        }

        function makeDate(date, format, isSelected, isSecondary) {
            return { date: date, label: dateFilter(date, format), selected: !!isSelected, secondary: !!isSecondary };
        }

        this.modes = [
            {
                name: 'day',
                getVisibleDates: function(date, selected) {
                    var year = date.getFullYear(), month = date.getMonth(), firstDayOfMonth = new Date(year, month, 1);
                    var difference = startingDay - firstDayOfMonth.getDay(),
                        numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
                        firstDate = new Date(firstDayOfMonth), numDates = 0;

                    if ( numDisplayedFromPreviousMonth > 0 ) {
                        firstDate.setDate( - numDisplayedFromPreviousMonth + 1 );
                        numDates += numDisplayedFromPreviousMonth; // Previous
                    }
                    numDates += getDaysInMonth(year, month + 1); // Current
                    numDates += (7 - numDates % 7) % 7; // Next

                    var days = getDates(firstDate, numDates), labels = new Array(7);
                    for (var i = 0; i < numDates; i ++) {
                        var dt = new Date(days[i]);
                        days[i] = makeDate(dt, format.day, (selected && selected.getDate() === dt.getDate() && selected.getMonth() === dt.getMonth() && selected.getFullYear() === dt.getFullYear()), dt.getMonth() !== month);
                    }
                    for (var j = 0; j < 7; j++) {
                        labels[j] = dateFilter(days[j].date, format.dayHeader);
                    }
                    return { objects: days, title: dateFilter(date, format.dayTitle), labels: labels };
                },
                compare: function(date1, date2) {
                    return (new Date( date1.getFullYear(), date1.getMonth(), date1.getDate() ) - new Date( date2.getFullYear(), date2.getMonth(), date2.getDate() ) );
                },
                split: 7,
                step: { months: 1 }
            },
            {
                name: 'month',
                getVisibleDates: function(date, selected) {
                    var months = new Array(12), year = date.getFullYear();
                    for ( var i = 0; i < 12; i++ ) {
                        var dt = new Date(year, i, 1);
                        months[i] = makeDate(dt, format.month, (selected && selected.getMonth() === i && selected.getFullYear() === year));
                    }
                    return { objects: months, title: dateFilter(date, format.monthTitle) };
                },
                compare: function(date1, date2) {
                    return new Date( date1.getFullYear(), date1.getMonth() ) - new Date( date2.getFullYear(), date2.getMonth() );
                },
                split: 3,
                step: { years: 1 }
            },
            {
                name: 'year',
                getVisibleDates: function(date, selected) {
                    var years = new Array(yearRange), year = date.getFullYear(), startYear = parseInt((year - 1) / yearRange, 10) * yearRange + 1;
                    for ( var i = 0; i < yearRange; i++ ) {
                        var dt = new Date(startYear + i, 0, 1);
                        years[i] = makeDate(dt, format.year, (selected && selected.getFullYear() === dt.getFullYear()));
                    }
                    return { objects: years, title: [years[0].label, years[yearRange - 1].label].join(' - ') };
                },
                compare: function(date1, date2) {
                    return date1.getFullYear() - date2.getFullYear();
                },
                split: 5,
                step: { years: yearRange }
            }
        ];

        this.isDisabled = function(date, mode) {
            var currentMode = this.modes[mode || 0];
            return ((this.minDate && currentMode.compare(date, this.minDate) < 0) || (this.maxDate && currentMode.compare(date, this.maxDate) > 0) || ($scope.dateDisabled && $scope.dateDisabled({date: date, mode: currentMode.name})));
        };
    }])

    .directive( 'datepicker', ['dateFilter', '$parse', 'datepickerConfig', '$log', function (dateFilter, $parse, datepickerConfig, $log) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'template/datepicker/datepicker.html',
            scope: {
                dateDisabled: '&'
            },
            require: ['datepicker', '?^ngModel'],
            controller: 'DatepickerController',
            link: function(scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0], ngModel = ctrls[1];

                if (!ngModel) {
                    return; // do nothing if no ng-model
                }

                // Configuration parameters
                var mode = 0, selected = new Date(), showWeeks = datepickerConfig.showWeeks;

                if (attrs.showWeeks) {
                    scope.$parent.$watch($parse(attrs.showWeeks), function(value) {
                        showWeeks = !! value;
                        updateShowWeekNumbers();
                    });
                } else {
                    updateShowWeekNumbers();
                }

                if (attrs.min) {
                    scope.$parent.$watch($parse(attrs.min), function(value) {
                        datepickerCtrl.minDate = value ? new Date(value) : null;
                        refill();
                    });
                }
                if (attrs.max) {
                    scope.$parent.$watch($parse(attrs.max), function(value) {
                        datepickerCtrl.maxDate = value ? new Date(value) : null;
                        refill();
                    });
                }

                function updateShowWeekNumbers() {
                    scope.showWeekNumbers = mode === 0 && showWeeks;
                }

                // Split array into smaller arrays
                function split(arr, size) {
                    var arrays = [];
                    while (arr.length > 0) {
                        arrays.push(arr.splice(0, size));
                    }
                    return arrays;
                }

                function refill( updateSelected ) {
                    var date = null, valid = true;

                    if ( ngModel.$modelValue ) {
                        date = new Date( ngModel.$modelValue );

                        if ( isNaN(date) ) {
                            valid = false;
                            $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
                        } else if ( updateSelected ) {
                            selected = date;
                        }
                    }
                    ngModel.$setValidity('date', valid);

                    var currentMode = datepickerCtrl.modes[mode], data = currentMode.getVisibleDates(selected, date);
                    angular.forEach(data.objects, function(obj) {
                        obj.disabled = datepickerCtrl.isDisabled(obj.date, mode);
                    });

                    ngModel.$setValidity('date-disabled', (!date || !datepickerCtrl.isDisabled(date)));

                    scope.rows = split(data.objects, currentMode.split);
                    scope.labels = data.labels || [];
                    scope.title = data.title;
                }

                function setMode(value) {
                    mode = value;
                    updateShowWeekNumbers();
                    refill();
                }

                ngModel.$render = function() {
                    refill( true );
                };

                scope.select = function( date ) {
                    if ( mode === 0 ) {
                        var dt = new Date( ngModel.$modelValue );
                        dt.setFullYear( date.getFullYear(), date.getMonth(), date.getDate() );
                        ngModel.$setViewValue( dt );
                        refill( true );
                    } else {
                        selected = date;
                        setMode( mode - 1 );
                    }
                };
                scope.move = function(direction) {
                    var step = datepickerCtrl.modes[mode].step;
                    selected.setMonth( selected.getMonth() + direction * (step.months || 0) );
                    selected.setFullYear( selected.getFullYear() + direction * (step.years || 0) );
                    refill();
                };
                scope.toggleMode = function() {
                    setMode( (mode + 1) % datepickerCtrl.modes.length );
                };
                scope.getWeekNumber = function(row) {
                    return ( mode === 0 && scope.showWeekNumbers && row.length === 7 ) ? getISO8601WeekNumber(row[0].date) : null;
                };

                function getISO8601WeekNumber(date) {
                    var checkDate = new Date(date);
                    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
                    var time = checkDate.getTime();
                    checkDate.setMonth(0); // Compare with Jan 1
                    checkDate.setDate(1);
                    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
                }
            }
        };
    }])

    .constant('datepickerPopupConfig', {
        dateFormat: 'yyyy-MM-dd',
        closeOnDateSelection: true
    })

    .directive('datepickerPopup', ['$compile', '$parse', '$document', '$position', 'dateFilter', 'datepickerPopupConfig',"$log",
        function ($compile, $parse, $document, $position, dateFilter, datepickerPopupConfig,$log) {
            return {
                restrict: 'EA',
                require: 'ngModel',
                link: function(originalScope, element, attrs, ngModel) {

                    var closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
                    var dateFormat = attrs.datepickerPopup || datepickerPopupConfig.dateFormat;

                    // create a child scope for the datepicker directive so we are not polluting original scope
                    var scope = originalScope.$new();
                    originalScope.$on('$destroy', function() {
                        scope.$destroy();
                    });

                    function formatDate(value) {
                        return (value) ? dateFilter(value, dateFormat) : null;
                    }
                    ngModel.$formatters.push(formatDate);

                    // TODO: reverse from dateFilter string to Date object
                    function parseDate(value) {
                        if ( value ) {
                            var date = new Date(value);
                            if (!isNaN(date)) {
                                return date;
                            }
                        }
                        return value;
                    }
                    ngModel.$parsers.push(parseDate);

                    var getIsOpen, setIsOpen;
                    if ( attrs.open ) {
                        getIsOpen = $parse(attrs.open);
                        setIsOpen = getIsOpen.assign;

                        originalScope.$watch(getIsOpen, function updateOpen(value) {
                            scope.isOpen = !! value;
                        });
                    }
                    scope.isOpen = getIsOpen ? getIsOpen(originalScope) : false; // Initial state

                    function setOpen( value ) {
                        if (setIsOpen) {
                            setIsOpen(originalScope, !!value);
                        } else {
                            scope.isOpen = !!value;
                        }
                    }

                    var documentClickBind = function(event) {
                        if (scope.isOpen && event.target !== element[0]) {
                            scope.$apply(function() {
                                setOpen(false);
                            });
                        }
                    };

                    var elementFocusBind = function() {
                        scope.$apply(function() {
                            setOpen( true );
                        });
                    };

                    // popup element used to display calendar
                    var popupEl = angular.element('<datepicker-popup-wrap><datepicker></datepicker></datepicker-popup-wrap>');
                    popupEl.attr({
                        'ng-model': 'date',
                        'ng-change': 'dateSelection()'
                    });
                    var datepickerEl = popupEl.find('datepicker');
                    if (attrs.datepickerOptions) {
                        datepickerEl.attr(angular.extend({}, originalScope.$eval(attrs.datepickerOptions)));
                    }

                    var $setModelValue = $parse(attrs.ngModel).assign;

                    // Inner change
                    scope.dateSelection = function() {
                        $setModelValue(originalScope, scope.date);
                        if (closeOnDateSelection) {
                            setOpen( false );
                        }
                    };

                    // Outter change
                    scope.$watch(function() {
                        return ngModel.$modelValue;
                    }, function(value) {
                        if (angular.isString(value)) {
                            var date = parseDate(value);

                            if (value && !date) {
                                $setModelValue(originalScope, null);
                                throw new Error(value + ' cannot be parsed to a date object.');
                            } else {
                                value = date;
                            }
                        }
                        scope.date = value;
                        //  updatePosition();
                    });

                    function addWatchableAttribute(attribute, scopeProperty, datepickerAttribute) {
                        if (attribute) {
                            originalScope.$watch($parse(attribute), function(value){
                                scope[scopeProperty] = value;
                            });
                            datepickerEl.attr(datepickerAttribute || scopeProperty, scopeProperty);
                        }
                    }
                    addWatchableAttribute(attrs.min, 'min');
                    addWatchableAttribute(attrs.max, 'max');
                    if (attrs.showWeeks) {
                        addWatchableAttribute(attrs.showWeeks, 'showWeeks', 'show-weeks');
                    } else {
                        scope.showWeeks = true;
                        datepickerEl.attr('show-weeks', 'showWeeks');
                    }
                    if (attrs.dateDisabled) {
                        datepickerEl.attr('date-disabled', attrs.dateDisabled);
                    }

                    function updatePosition() {
                        var displayPos = element[0].getBoundingClientRect();
                        scope.position ={
                            top:displayPos.top+element.prop('offsetHeight'),
                            left:displayPos.left
                        };

                        var h = element.height();

                        if(h<400)
                            h=400;
                        var w = element.width();

                        if(scope.position.top + h > $(window).height()) {
                            scope.position.top = $(window).height()-h;
                        }

                    }

                    scope.$watch('isOpen', function(value) {
                        if (value) {
                            updatePosition();
                            $document.bind('click', documentClickBind);
                            element.unbind('focus', elementFocusBind);
                            element.focus();
                        } else {
                            $document.unbind('click', documentClickBind);
                            element.bind('focus', elementFocusBind);
                        }

                        if ( setIsOpen ) {
                            setIsOpen(originalScope, value);
                        }
                    });

                    scope.today = function() {
                        $setModelValue(originalScope, new Date());
                    };
                    scope.clear = function() {
                        $setModelValue(originalScope, null);
                    };

                    element.after($compile(popupEl)(scope));
                }
            };
        }])

    .directive('datepickerPopupWrap', [function() {
        return {
            restrict:'E',
            replace: true,
            transclude: true,
            templateUrl: 'template/datepicker/popup.html',
            link:function (scope, element, attrs) {
                element.bind('click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        };
    }]);
// The `$dialogProvider` can be used to configure global defaults for your
// `$dialog` service.
var dialogModule = angular.module('ui.bootstrap.dialog', ['ui.bootstrap.transition']);

dialogModule.controller('MessageBoxController', ['$scope', 'dialog', 'model', function($scope, dialog, model){
    $scope.title = model.title;
    $scope.message = model.message;
    $scope.buttons = model.buttons;
    $scope.close = function(res){
        dialog.close(res);
    };
}]);

dialogModule.provider("$dialog", function(){

    // The default options for all dialogs.
    var defaults = {
        backdrop: true,
        dialogClass: 'modal',
        backdropClass: 'modal-backdrop',
        transitionClass: 'fade',
        triggerClass: 'in',
        resolve:{},
        backdropFade: false,
        dialogFade:false,
        keyboard: true, // close with esc key
        backdropClick: true // only in conjunction with backdrop=true
        /* other options: template, templateUrl, controller */
    };

    var globalOptions = {};

    // The `options({})` allows global configuration of all dialogs in the application.
    //
    //      var app = angular.module('App', ['ui.bootstrap.dialog'], function($dialogProvider){
    //        // don't close dialog when backdrop is clicked by default
    //        $dialogProvider.options({backdropClick: false});
    //      });
    this.options = function(value){
        globalOptions = value;
    };

    // Returns the actual `$dialog` service that is injected in controllers
    this.$get = ["$http", "$document", "$compile", "$rootScope", "$controller", "$templateCache", "$q", "$transition", "$injector",
        function ($http, $document, $compile, $rootScope, $controller, $templateCache, $q, $transition, $injector) {

            var body = $document.find('body');

            function createElement(clazz) {
                var el = angular.element("<div>");
                el.addClass(clazz);
                return el;
            }

            // The `Dialog` class represents a modal dialog. The dialog class can be invoked by providing an options object
            // containing at lest template or templateUrl and controller:
            //
            //     var d = new Dialog({templateUrl: 'foo.html', controller: 'BarController'});
            //
            // Dialogs can also be created using templateUrl and controller as distinct arguments:
            //
            //     var d = new Dialog('path/to/dialog.html', MyDialogController);
            function Dialog(opts) {

                var self = this, options = this.options = angular.extend({}, defaults, globalOptions, opts);
                this._open = false;

                this.backdropEl = createElement(options.backdropClass);
                if(options.backdropFade){
                    this.backdropEl.addClass(options.transitionClass);
                    this.backdropEl.removeClass(options.triggerClass);
                }

                this.modalEl = createElement(options.dialogClass);
                if(options.dialogFade){
                    this.modalEl.addClass(options.transitionClass);
                    this.modalEl.removeClass(options.triggerClass);
                }

                this.handledEscapeKey = function(e) {
                    if (e.which === 27) {
                        self.close();
                        e.preventDefault();
                        self.$scope.$apply();
                    }
                };

                this.handleBackDropClick = function(e) {
                    self.close();
                    e.preventDefault();
                    self.$scope.$apply();
                };

                $rootScope.$on('$routeChangeSuccess', function() {
                    if(self.isOpen()) {
                        self.close();
                    }
                });
            }

            // The `isOpen()` method returns wether the dialog is currently visible.
            Dialog.prototype.isOpen = function(){
                return this._open;
            };

            // The `open(templateUrl, controller)` method opens the dialog.
            // Use the `templateUrl` and `controller` arguments if specifying them at dialog creation time is not desired.
            Dialog.prototype.open = function(templateUrl, controller){
                var self = this, options = this.options;

                if(templateUrl){
                    options.templateUrl = templateUrl;
                }
                if(controller){
                    options.controller = controller;
                }

                if(!(options.template || options.templateUrl)) {
                    throw new Error('Dialog.open expected template or templateUrl, neither found. Use options or open method to specify them.');
                }

                this._loadResolves().then(function(locals) {
                    var $scope = locals.$scope = self.$scope = locals.$scope ? locals.$scope : $rootScope.$new();

                    self.modalEl.html(locals.$template);

                    if (self.options.controller) {
                        var ctrl = $controller(self.options.controller, locals);
                        self.modalEl.children().data('ngControllerController', ctrl);
                    }

                    if(self.options.extraScope) {
                        if (self.compiledScope) { //cfn fix of dialog problems
                            self.compiledScope.$destroy();
                        }
                        self.compiledScope = $scope.$new();
                    } else {
                        self.compiledScope = $scope;
                    }

                    $compile(self.modalEl)(self.compiledScope);

                    self._addElementsToDom();

                    // trigger tranisitions
                    setTimeout(function(){
                        if(self.options.dialogFade){ self.modalEl.addClass(self.options.triggerClass); }
                        if(self.options.backdropFade){ self.backdropEl.addClass(self.options.triggerClass); }
                        // CFNPOC-19756 clear focus
                        self.modalEl.find('button').focus();
                        self.modalEl.find('button').blur();
                    });

                    self._bindEvents();

                    $rootScope.$broadcast("dialogOpen");
                    // cfn arne
                    if(self.options.cfnAutoPositionSelector){
                        ang.callAfter(function(){
                            var displayPos = $(self.options.cfnAutoPositionSelector)[0].getBoundingClientRect();

                            if($(self.modalEl).width()>displayPos.width){
                                self.modalEl.css("left",((displayPos.left+displayPos.width)-$(self.modalEl).width())+"px");
                            }else{
                                self.modalEl.css("left",displayPos.left+"px");
                            }
                            self.modalEl.css("top",displayPos.bottom +"px");
                            self.modalEl.css("position","fixed");
                        },$scope);
                    }
                });

                this.deferred = $q.defer();
                return this.deferred.promise;
            };

            // closes the dialog and resolves the promise returned by the `open` method with the specified result.
            Dialog.prototype.close = function(result){
                var self = this;
                var fadingElements = this._getFadingElements();

                if(fadingElements.length > 0){
                    for (var i = fadingElements.length - 1; i >= 0; i--) {
                        $transition(fadingElements[i], removeTriggerClass).then(onCloseComplete);
                    }
                    return;
                }

                this._onCloseComplete(result);

                function removeTriggerClass(el){
                    el.removeClass(self.options.triggerClass);
                }

                function onCloseComplete(){
                    if(self._open){
                        self._onCloseComplete(result);
                    }
                }
            };

            Dialog.prototype._getFadingElements = function(){
                var elements = [];
                if(this.options.dialogFade){
                    elements.push(this.modalEl);
                }
                if(this.options.backdropFade){
                    elements.push(this.backdropEl);
                }

                return elements;
            };

            Dialog.prototype._bindEvents = function() {
                if(this.options.keyboard){ body.bind('keydown', this.handledEscapeKey); }
                if(this.options.backdrop && this.options.backdropClick){ this.backdropEl.bind('click', this.handleBackDropClick); }
            };

            Dialog.prototype._unbindEvents = function() {
                if(this.options.keyboard){ body.unbind('keydown', this.handledEscapeKey); }
                if(this.options.backdrop && this.options.backdropClick){ this.backdropEl.unbind('click', this.handleBackDropClick); }
            };

            Dialog.prototype._onCloseComplete = function(result) {
                this._removeElementsFromDom();
                this._unbindEvents();

                this.deferred.resolve(result);
            };

            Dialog.prototype._addElementsToDom = function(){
                body.append(this.modalEl);

                if(this.options.backdrop) {
                    body.append(this.backdropEl);
                }

                this._open = true;
            };

            Dialog.prototype._removeElementsFromDom = function(){
                this.modalEl.remove();

                if(this.options.backdrop) {
                    this.backdropEl.remove();
                }
                this._open = false;
            };

            // Loads all `options.resolve` members to be used as locals for the controller associated with the dialog.
            Dialog.prototype._loadResolves = function(){
                var values = [], keys = [], templatePromise, self = this;

                if (this.options.template) {
                    templatePromise = $q.when(this.options.template);
                } else if (this.options.templateUrl) {
                    templatePromise = $http.get(this.options.templateUrl, {cache:$templateCache})
                        .then(function(response) { return response.data; });
                }

                angular.forEach(this.options.resolve || [], function(value, key) {
                    keys.push(key);
                    values.push(angular.isString(value) ? $injector.get(value) : $injector.invoke(value));
                });

                keys.push('$template');
                values.push(templatePromise);

                return $q.all(values).then(function(values) {
                    var locals = {};
                    angular.forEach(values, function(value, index) {
                        locals[keys[index]] = value;
                    });
                    locals.dialog = self;
                    return locals;
                });
            };

            // The actual `$dialog` service that is injected in controllers.
            return {
                // Creates a new `Dialog` with the specified options.
                dialog: function(opts){
                    return new Dialog(opts);
                },
                // creates a new `Dialog` tied to the default message box template and controller.
                //
                // Arguments `title` and `message` are rendered in the modal header and body sections respectively.
                // The `buttons` array holds an object with the following members for each button to include in the
                // modal footer section:
                //
                // * `result`: the result to pass to the `close` method of the dialog when the button is clicked
                // * `label`: the label of the button
                // * `cssClass`: additional css class(es) to apply to the button for styling
                messageBox: function(title, message, buttons){
                    return new Dialog({templateUrl: 'template/dialog/message.html', controller: 'MessageBoxController', resolve:
                    {model: function() {
                        return {
                            title: title,
                            message: message,
                            buttons: buttons
                        };
                    }
                    }});
                }
            };
        }];
});

/*
 * dropdownToggle - Provides dropdown menu functionality in place of bootstrap js
 * @restrict class or attribute
 * @example:
 <li class="dropdown">
 <a class="dropdown-toggle">My Dropdown Menu</a>
 <ul class="dropdown-menu">
 <li ng-repeat="choice in dropChoices">
 <a ng-href="{{choice.href}}">{{choice.text}}</a>
 </li>
 </ul>
 </li>
 */

angular.module('ui.bootstrap.dropdownToggle', []).directive('dropdownToggle', ['$document', '$location', function ($document, $location) {
    var openElement = null,
        closeMenu   = angular.noop;
    return {
        restrict: 'CA',
        link: function(scope, element, attrs) {
            scope.$watch('$location.path', function() { closeMenu(); });
            element.parent().bind('click', function() { closeMenu(); });
            element.bind('click', function (event) {

                var elementWasOpen = (element === openElement);

                event.preventDefault();
                event.stopPropagation();

                if (!!openElement) {
                    closeMenu();
                }

                if (!elementWasOpen) {
                    element.parent().addClass('open');
                    openElement = element;
                    closeMenu = function (event) {
                        if (event) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        $document.unbind('click', closeMenu);
                        element.parent().removeClass('open');
                        closeMenu = angular.noop;
                        openElement = null;
                    };
                    $document.bind('click', closeMenu);
                }
            });
        }
    };
}]);
angular.module('ui.bootstrap.modal', ['ui.bootstrap.dialog'])
    .directive('modal', ['$parse', '$dialog','$rootScope', function($parse, $dialog,$rootScope) {
        return {
            restrict: 'EA',
            terminal: true,
            link: function(scope, elm, attrs) {
                var opts = angular.extend({}, scope.$eval(attrs.uiOptions || attrs.bsOptions || attrs.options));
                var shownExpr = attrs.modal || attrs.show;
                var setClosed;

                // Create a dialog with the template as the contents of the directive
                // Add the current scope as the resolve in order to make the directive scope as a dialog controller scope
                opts = angular.extend(opts, {
                    template: elm.html(),
                    resolve: { $scope: function() { return scope; } }
                });
                var dialog = $dialog.dialog(opts);

                elm.remove();

                if (attrs.close) {
                    setClosed = function() {
                        $rootScope.modalActive=false;
                        $parse(attrs.close)(scope);
                    };
                } else {
                    setClosed = function() {
                        $rootScope.modalActive=false;
                        if (angular.isFunction($parse(shownExpr).assign)) {
                            $parse(shownExpr).assign(scope, false);
                        }
                    };
                }

                scope.$watch(shownExpr, function(isShown, oldShown) {
                    if (isShown) {
                        $rootScope.modalActive=true;
                        dialog.open().then(function(){
                            setClosed();
                        });
                    } else {
                        //Make sure it is not opened
                        if (dialog.isOpen()){
                            $rootScope.modalActive=false;
                            dialog.close();
                        }
                    }
                });
            }
        };
    }]);
angular.module('ui.bootstrap.pagination', [])

    .controller('PaginationController', ['$scope', '$interpolate', function ($scope, $interpolate) {

        this.currentPage = 1;

        this.noPrevious = function() {
            return this.currentPage === 1;
        };
        this.noNext = function() {
            return this.currentPage === $scope.numPages;
        };

        this.isActive = function(page) {
            return this.currentPage === page;
        };

        this.reset = function() {
            $scope.pages = [];
            this.currentPage = parseInt($scope.currentPage, 10);

            if ( this.currentPage > $scope.numPages ) {
                $scope.selectPage($scope.numPages);
            }
        };

        var self = this;
        $scope.selectPage = function(page) {
            if ( ! self.isActive(page) && page > 0 && page <= $scope.numPages) {
                $scope.currentPage = page;
                $scope.onSelectPage({ page: page });
            }
        };

        this.getAttributeValue = function(attribute, defaultValue, interpolate) {
            return angular.isDefined(attribute) ? (interpolate ? $interpolate(attribute)($scope.$parent) : $scope.$parent.$eval(attribute)) : defaultValue;
        };
    }])

    .constant('paginationConfig', {
        boundaryLinks: false,
        directionLinks: true,
        firstText: 'First',
        previousText: 'Previous',
        nextText: 'Next',
        lastText: 'Last',
        rotate: true
    })

    .directive('pagination', ['paginationConfig', function(config) {
        return {
            restrict: 'EA',
            scope: {
                numPages: '=',
                currentPage: '=',
                maxSize: '=',
                onSelectPage: '&'
            },
            controller: 'PaginationController',
            templateUrl: 'template/pagination/pagination.html',
            replace: true,
            link: function(scope, element, attrs, paginationCtrl) {

                // Setup configuration parameters
                var boundaryLinks = paginationCtrl.getAttributeValue(attrs.boundaryLinks,  config.boundaryLinks      ),
                    directionLinks    = paginationCtrl.getAttributeValue(attrs.directionLinks, config.directionLinks     ),
                    firstText         = paginationCtrl.getAttributeValue(attrs.firstText,      config.firstText,     true),
                    previousText      = paginationCtrl.getAttributeValue(attrs.previousText,   config.previousText,  true),
                    nextText          = paginationCtrl.getAttributeValue(attrs.nextText,       config.nextText,      true),
                    lastText          = paginationCtrl.getAttributeValue(attrs.lastText,       config.lastText,      true),
                    rotate            = paginationCtrl.getAttributeValue(attrs.rotate,         config.rotate);

                // Create page object used in template
                function makePage(number, text, isActive, isDisabled) {
                    return {
                        number: number,
                        text: text,
                        active: isActive,
                        disabled: isDisabled
                    };
                }

                scope.$watch('numPages + currentPage + maxSize', function() {
                    paginationCtrl.reset();

                    // Default page limits
                    var startPage = 1, endPage = scope.numPages;
                    var isMaxSized = ( angular.isDefined(scope.maxSize) && scope.maxSize < scope.numPages );

                    // recompute if maxSize
                    if ( isMaxSized ) {
                        if ( rotate ) {
                            // Current page is displayed in the middle of the visible ones
                            startPage = Math.max(paginationCtrl.currentPage - Math.floor(scope.maxSize/2), 1);
                            endPage   = startPage + scope.maxSize - 1;

                            // Adjust if limit is exceeded
                            if (endPage > scope.numPages) {
                                endPage   = scope.numPages;
                                startPage = endPage - scope.maxSize + 1;
                            }
                        } else {
                            // Visible pages are paginated with maxSize
                            startPage = ((Math.ceil(paginationCtrl.currentPage / scope.maxSize) - 1) * scope.maxSize) + 1;

                            // Adjust last page if limit is exceeded
                            endPage = Math.min(startPage + scope.maxSize - 1, scope.numPages);
                        }
                    }

                    // Add page number links
                    for (var number = startPage; number <= endPage; number++) {
                        var page = makePage(number, number, paginationCtrl.isActive(number), false);
                        scope.pages.push(page);
                    }

                    // Add links to move between page sets
                    if ( isMaxSized && ! rotate ) {
                        if ( startPage > 1 ) {
                            var previousPageSet = makePage(startPage - 1, '...', false, false);
                            scope.pages.unshift(previousPageSet);
                        }

                        if ( endPage < scope.numPages ) {
                            var nextPageSet = makePage(endPage + 1, '...', false, false);
                            scope.pages.push(nextPageSet);
                        }
                    }

                    // Add previous & next links
                    if (directionLinks) {
                        var previousPage = makePage(paginationCtrl.currentPage - 1, previousText, false, paginationCtrl.noPrevious());
                        scope.pages.unshift(previousPage);

                        var nextPage = makePage(paginationCtrl.currentPage + 1, nextText, false, paginationCtrl.noNext());
                        scope.pages.push(nextPage);
                    }

                    // Add first & last links
                    if (boundaryLinks) {
                        var firstPage = makePage(1, firstText, false, paginationCtrl.noPrevious());
                        scope.pages.unshift(firstPage);

                        var lastPage = makePage(scope.numPages, lastText, false, paginationCtrl.noNext());
                        scope.pages.push(lastPage);
                    }
                });
            }
        };
    }])

    .constant('pagerConfig', {
        previousText: 'Â« Previous',
        nextText: 'Next Â»',
        align: true
    })

    .directive('pager', ['pagerConfig', function(config) {
        return {
            restrict: 'EA',
            scope: {
                numPages: '=',
                currentPage: '=',
                onSelectPage: '&'
            },
            controller: 'PaginationController',
            templateUrl: 'template/pagination/pager.html',
            replace: true,
            link: function(scope, element, attrs, paginationCtrl) {

                // Setup configuration parameters
                var previousText = paginationCtrl.getAttributeValue(attrs.previousText, config.previousText, true),
                    nextText         = paginationCtrl.getAttributeValue(attrs.nextText,     config.nextText,     true),
                    align            = paginationCtrl.getAttributeValue(attrs.align,        config.align);

                // Create page object used in template
                function makePage(number, text, isDisabled, isPrevious, isNext) {
                    return {
                        number: number,
                        text: text,
                        disabled: isDisabled,
                        previous: ( align && isPrevious ),
                        next: ( align && isNext )
                    };
                }

                scope.$watch('numPages + currentPage', function() {
                    paginationCtrl.reset();

                    // Add previous & next links
                    var previousPage = makePage(paginationCtrl.currentPage - 1, previousText, paginationCtrl.noPrevious(), true, false);
                    scope.pages.unshift(previousPage);

                    var nextPage = makePage(paginationCtrl.currentPage + 1, nextText, paginationCtrl.noNext(), false, true);
                    scope.pages.push(nextPage);
                });
            }
        };
    }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module( 'ui.bootstrap.tooltip', [ 'ui.bootstrap.position' ] )

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
    .provider( '$tooltip', function () {
        // The default options tooltip and popover.
        var defaultOptions = {
            placement: 'top',
            animation: true,
            popupDelay: 0
        };

        // Default hide triggers for each show trigger
        var triggerMap = {
            'mouseenter': 'mouseleave',
            'click': 'click',
            'focus': 'blur'
        };

        // The options specified to the provider globally.
        var globalOptions = {};

        /**
         * `options({})` allows global configuration of all tooltips in the
         * application.
         *
         *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
         */
        this.options = function( value ) {
            angular.extend( globalOptions, value );
        };

        /**
         * This allows you to extend the set of trigger mappings available. E.g.:
         *
         *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
         */
        this.setTriggers = function setTriggers ( triggers ) {
            angular.extend( triggerMap, triggers );
        };

        /**
         * This is a helper function for translating camel-case to snake-case.
         */
        function snake_case(name){
            var regexp = /[A-Z]/g;
            var separator = '-';
            return name.replace(regexp, function(letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }

        /**
         * Returns the actual instance of the $tooltip service.
         * TODO support multiple triggers
         */
        this.$get = [ '$window', '$compile', '$timeout', '$parse', '$document', '$position', '$interpolate','$sce', function ( $window, $compile, $timeout, $parse, $document, $position, $interpolate,$sce ) {
            return function $tooltip ( type, prefix, defaultTriggerShow ) {
                var options = angular.extend( {}, defaultOptions, globalOptions );

                /**
                 * Returns an object of show and hide triggers.
                 *
                 * If a trigger is supplied,
                 * it is used to show the tooltip; otherwise, it will use the `trigger`
                 * option passed to the `$tooltipProvider.options` method; else it will
                 * default to the trigger supplied to this directive factory.
                 *
                 * The hide trigger is based on the show trigger. If the `trigger` option
                 * was passed to the `$tooltipProvider.options` method, it will use the
                 * mapped trigger from `triggerMap` or the passed trigger if the map is
                 * undefined; otherwise, it uses the `triggerMap` value of the show
                 * trigger; else it will just use the show trigger.
                 */
                function getTriggers ( trigger ) {
                    var show = trigger || options.trigger || defaultTriggerShow;
                    var hide = triggerMap[show] || show;
                    return {
                        show: show,
                        hide: hide
                    };
                }

                var directiveName = snake_case( type );

                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template =
                    '<'+ directiveName +'-popup '+
                    'titletext="'+startSym+'tt_titletext'+endSym+'" '+
                    'titlelink="'+startSym+'tt_titlelink'+endSym+'" ' +
                    'content="'+startSym+'tt_content'+endSym+'" '+
                    'placement="'+startSym+'tt_placement'+endSym+'" '+
                    'animation="tt_animation()" '+
                    'is-open="tt_isOpen"'+
                    '>'+
                    '</'+ directiveName +'-popup>';

                return {
                    restrict: 'EA',
                    scope: true,
                    link: function link ( scope, element, attrs ) {

                        var recompile = false;
                        var tooltip = $compile( template )( scope );
                        var transitionTimeout;
                        var popupTimeout;
                        var $body;
                        var appendToBody = angular.isDefined( options.appendToBody ) ? options.appendToBody : false;
                        var triggers = getTriggers( undefined );
                        var hasRegisteredTriggers = false;

                        // By default, the tooltip is not open.
                        // TODO add ability to start tooltip opened
                        scope.tt_isOpen = false;

                        scope.onShow=[];
                        scope.registerShowTooltipHandler=function(func){
                            scope.onShow.push(func);
                        };

                        // called from other controllers !
                        scope.closePopover=function(){
                            hide();
                        };
                        // called from this component
                        scope.close = function(){
                            hideTooltipBind();
                        };
                        function toggleTooltipBind () {
                            if ( ! scope.tt_isOpen ) {
                                showTooltipBind();
                            } else {
                                hideTooltipBind();
                            }
                        }


                        // Show the tooltip with delay if specified, otherwise show it immediately
                        function showTooltipBind() {
                            tooltip.show();
                            if ( scope.tt_popupDelay ) {
                                popupTimeout = $timeout( show, scope.tt_popupDelay );
                            } else {
                                scope.$apply( show );
                            }
                        }

                        function hideTooltipBind () {
                            scope.$apply(function () {
                                hide();
                            });
                        }

                        // Show the tooltip popup element.
                        function show() {
                            var position,
                                ttWidth,
                                ttHeight,
                                ttPosition;
                            //
                            for(var i in scope.onShow)
                            {
                                scope.onShow[i](scope,tooltip);
                            }

                            // Don't show empty tooltips.
                            if ( ! scope.tt_content ) {
                                return;
                            }

                            // If there is a pending remove transition, we must cancel it, lest the
                            // tooltip be mysteriously removed.
                            if ( transitionTimeout ) {
                                $timeout.cancel( transitionTimeout );
                            }

                            // Set the initial positioning.
                            tooltip.css({ top: 0, left: 0, display: 'block' });

                            // Now we add it to the DOM because need some info about it. But it's not
                            // visible yet anyway.
                            if ( appendToBody ) {
                                $body = $body || $document.find( 'body' );
                                $body.append( tooltip );
                            } else {
                                element.after( tooltip );
                            }


                            tooltip.find(".close").unbind("click");
                            tooltip.find(".close").click(function(){
                                scope.close(); // because ng-click did not work..;
                            });

                            // Get the position of the directive element.
                            position = appendToBody ? $position.offset( element ) : $position.position( element );

                            // Get the height and width of the tooltip so we can center it.
                            ttWidth = tooltip.prop( 'offsetWidth' );
                            ttHeight = tooltip.prop( 'offsetHeight' );

                            // Calculate the tooltip's top and left coordinates to center it with
                            // this directive.
                            switch ( scope.tt_placement ) {
                                case 'mouse':
                                    var mousePos = $position.mouse();
                                    ttPosition = {
                                        top: mousePos.y,
                                        left: mousePos.x
                                    };
                                    break;
                                case 'right':
                                    ttPosition = {
                                        top: position.top + position.height / 2 - ttHeight / 2,
                                        left: position.left + position.width
                                    };
                                    break;
                                case 'bottom':
                                    ttPosition = {
                                        top: position.top + position.height,
                                        left: position.left + position.width / 2 - ttWidth / 2
                                    };
                                    break;
                                case 'left':
                                    ttPosition = {
                                        top: position.top + position.height / 2 - ttHeight / 2,
                                        left: position.left - ttWidth
                                    };
                                    break;
                                default:
                                    ttPosition = {
                                        top: position.top - ttHeight,
                                        left: position.left + position.width / 2 - ttWidth / 2
                                    };
                                    break;
                            }

                            ttPosition.top += 'px';
                            ttPosition.left += 'px';


                            var displayPos = element[0].getBoundingClientRect();

                            //console.debug(displayPos);
                            ttPosition ={
                                top:displayPos.top+element.prop('offsetHeight'),
                                left:displayPos.left - 0.5*tooltip.width()+element.width() *0.5
                            };




                            //TODO: better arrow position
                            var arrow = tooltip.find(".arrow");

                            var padding = 20;

                            arrow.show();
                            if(ttPosition.top+tooltip.height()+padding>$(window).height()){
                                ttPosition.top = $(window).height() - tooltip.height()-padding;
                                arrow.hide();
                            }
                            if(ttPosition.left+tooltip.width()+padding>$(window).width()){
                                ttPosition.left = $(window).width() - tooltip.width()-padding;
                                arrow.hide();
                            }
                            if(ttPosition.left<padding){
                                ttPosition.left = padding;
                                arrow.hide();
                            }

                            // Now set the calculated positioning.
                            tooltip.css( ttPosition );

                            // And show the tooltip.
                            scope.tt_isOpen = true;



                            $('html').click(function(event) {
                                if(!$(event.target).is(".popover , .popover *, .popover-btn,  .popover-btn *, .popover-inner-content *"))
                                {

                                    var allowed = true;


                                    if($(event.target).parents("body").length==0){
                                        allowed = false;
                                        console.debug("not closing because the clicked element is not part of the body.",$(event.target),$(event.target).parent(),event);
                                    }
                                    if(allowed){
                                        console.log("closing",event.target);
                                        console.debug(event);
                                        if ( scope.tt_isOpen ) {
                                            hideTooltipBind();
                                        }
                                    }
                                }
                            });


                        }

                        // Hide the tooltip popup element.
                        function hide() {
                            // First things first: we don't show it anymore.
                            scope.tt_isOpen = false;
                            recompile = true;
                            //  $('html').unbind("click.popover");
                            //if tooltip is going to be shown after delay, we must cancel this
                            $timeout.cancel( popupTimeout );

                            $('html').off("click");
                            // And now we remove it from the DOM. However, if we have animation, we
                            // need to wait for it to expire beforehand.
                            // FIXME: this is a placeholder for a port of the transitions library.
                            if ( angular.isDefined( scope.tt_animation ) && scope.tt_animation() ) {
                                transitionTimeout = $timeout( function () { tooltip.hide(); }, 500 );
                            } else {

                                tooltip.hide();
                            }
                        }

                        /**
                         * Observe the relevant attributes.
                         */
                        attrs.$observe( type, function ( val ) {
                            scope.tt_content = val;
                        });

                        attrs.$observe( prefix+'Titletext', function ( val ) {
                            scope.tt_titletext = val;
                        });
                        attrs.$observe( prefix+'Titlelink', function ( val ) {
                            scope.tt_titlelink =  val;

                        });
                        attrs.$observe( prefix+'Result', function ( val ) {
                            scope.tt_result = val;
                        });

                        attrs.$observe( prefix+'Placement', function ( val ) {
                            scope.tt_placement = angular.isDefined( val ) ? val : options.placement;
                        });

                        attrs.$observe( prefix+'Animation', function ( val ) {
                            scope.tt_animation = angular.isDefined( val ) ? $parse( val ) : function(){ return options.animation; };
                        });

                        attrs.$observe( prefix+'PopupDelay', function ( val ) {
                            var delay = parseInt( val, 10 );
                            scope.tt_popupDelay = ! isNaN(delay) ? delay : options.popupDelay;
                        });

                        function unregisterTriggers() {
                            element.unbind(triggers.show, showTooltipBind);
                            element.unbind(triggers.hide, hideTooltipBind);
                        }

                        function prepTriggers() {
                            var val = attrs[ prefix + 'Trigger' ];
                            unregisterTriggers();

                            triggers = getTriggers( val );

                            if ( triggers.show === triggers.hide ) {
                                element.bind( triggers.show, toggleTooltipBind );
                            } else {
                                element.bind( triggers.show, showTooltipBind );
                                element.bind( triggers.hide, hideTooltipBind );
                            }
                        }
                        prepTriggers();

                        attrs.$observe( prefix+'AppendToBody', function ( val ) {
                            appendToBody = angular.isDefined( val ) ? $parse( val )( scope ) : appendToBody;
                        });

                        // if a tooltip is attached to <body> we need to remove it on
                        // location change as its parent scope will probably not be destroyed
                        // by the change.
                        if ( appendToBody ) {


                            scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess () {
                                if ( scope.tt_isOpen ) {
                                    hide();
                                }
                            });
                        }

                        // Make sure tooltip is destroyed and removed.
                        scope.$on('$destroy', function onDestroyTooltip() {
                            if ( scope.tt_isOpen ) {
                                hide();
                                tooltip.remove();
                            } else {
                                tooltip.remove();
                            }
                            unregisterTriggers();
                        });
                    }
                };
            };
        }];
    })

    .directive( 'tooltipPopup', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: { content: '@', placement: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-popup.html'
        };
    })

    .directive( 'tooltip', [ '$tooltip', function ( $tooltip ) {
        return $tooltip( 'tooltip', 'tooltip', 'mouseenter' );
    }])

    .directive( 'tooltipHtmlUnsafePopup', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: { content: '@', placement: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
        };
    })

    .directive( 'tooltipHtmlUnsafe', [ '$tooltip', function ( $tooltip ) {
        return $tooltip( 'tooltipHtmlUnsafe', 'tooltip', 'mouseenter' );
    }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html popovers, and selector delegatation.
 */
angular.module( 'ui.bootstrap.popover', [ 'ui.bootstrap.tooltip' ] )
    .directive( 'data365PopoverPopup', ['$sce', function ($sce) {
        return {
            restrict: 'EA',
            replace: true,
            scope: { titletext: '@', titlelink: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/popover/popover.html',
            link: function(scope, element) {
                scope.unsafetitlelink=$sce.trustAsHtml(scope.titlelink);
            }
        };
    }])
    .directive( 'data365Popover', [ '$compile', '$timeout', '$parse', '$window', '$tooltip', function ( $compile, $timeout, $parse, $window, $tooltip ) {
        return $tooltip( 'data365Popover', 'popover', 'click' );
    }]);


angular.module('ui.bootstrap.progressbar', ['ui.bootstrap.transition'])

    .constant('progressConfig', {
        animate: true,
        autoType: false,
        stackedTypes: ['success', 'info', 'warning', 'danger']
    })

    .controller('ProgressBarController', ['$scope', '$attrs', 'progressConfig', function($scope, $attrs, progressConfig) {

        // Whether bar transitions should be animated
        var animate = angular.isDefined($attrs.animate) ? $scope.$eval($attrs.animate) : progressConfig.animate;
        var autoType = angular.isDefined($attrs.autoType) ? $scope.$eval($attrs.autoType) : progressConfig.autoType;
        var stackedTypes = angular.isDefined($attrs.stackedTypes) ? $scope.$eval('[' + $attrs.stackedTypes + ']') : progressConfig.stackedTypes;

        // Create bar object
        this.makeBar = function(newBar, oldBar, index) {
            var newValue = (angular.isObject(newBar)) ? newBar.value : (newBar || 0);
            var oldValue =  (angular.isObject(oldBar)) ? oldBar.value : (oldBar || 0);
            var type = (angular.isObject(newBar) && angular.isDefined(newBar.type)) ? newBar.type : (autoType) ? getStackedType(index || 0) : null;

            return {
                from: oldValue,
                to: newValue,
                type: type,
                animate: animate
            };
        };

        function getStackedType(index) {
            return stackedTypes[index];
        }

        this.addBar = function(bar) {
            $scope.bars.push(bar);
            $scope.totalPercent += bar.to;
        };

        this.clearBars = function() {
            $scope.bars = [];
            $scope.totalPercent = 0;
        };
        this.clearBars();
    }])

    .directive('progress', function() {
        return {
            restrict: 'EA',
            replace: true,
            controller: 'ProgressBarController',
            scope: {
                value: '=percent',
                onFull: '&',
                onEmpty: '&'
            },
            templateUrl: 'template/progressbar/progress.html',
            link: function(scope, element, attrs, controller) {
                scope.$watch('value', function(newValue, oldValue) {
                    controller.clearBars();

                    if (angular.isArray(newValue)) {
                        // Stacked progress bar
                        for (var i=0, n=newValue.length; i < n; i++) {
                            controller.addBar(controller.makeBar(newValue[i], oldValue[i], i));
                        }
                    } else {
                        // Simple bar
                        controller.addBar(controller.makeBar(newValue, oldValue));
                    }
                }, true);

                // Total percent listeners
                scope.$watch('totalPercent', function(value) {
                    if (value >= 100) {
                        scope.onFull();
                    } else if (value <= 0) {
                        scope.onEmpty();
                    }
                }, true);
            }
        };
    })

    .directive('progressbar', ['$transition', function($transition) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                width: '=',
                old: '=',
                type: '=',
                animate: '='
            },
            templateUrl: 'template/progressbar/bar.html',
            link: function(scope, element) {
                scope.$watch('width', function(value) {
                    if (scope.animate) {
                        element.css('width', scope.old + '%');
                        $transition(element, {width: value + '%'});
                    } else {
                        element.css('width', value + '%');
                    }
                });
            }
        };
    }]);
angular.module('ui.bootstrap.rating', [])

    .constant('ratingConfig', {
        max: 5
    })

    .directive('rating', ['ratingConfig', '$parse', function(ratingConfig, $parse) {
        return {
            restrict: 'EA',
            scope: {
                value: '=',
                onHover: '&',
                onLeave: '&'
            },
            templateUrl: 'template/rating/rating.html',
            replace: true,
            link: function(scope, element, attrs) {

                var maxRange = angular.isDefined(attrs.max) ? scope.$parent.$eval(attrs.max) : ratingConfig.max;

                scope.range = [];
                for (var i = 1; i <= maxRange; i++) {
                    scope.range.push(i);
                }

                scope.rate = function(value) {
                    if ( ! scope.readonly ) {
                        scope.value = value;
                    }
                };

                scope.enter = function(value) {
                    if ( ! scope.readonly ) {
                        scope.val = value;
                    }
                    scope.onHover({value: value});
                };

                scope.reset = function() {
                    scope.val = angular.copy(scope.value);
                    scope.onLeave();
                };
                scope.reset();

                scope.$watch('value', function(value) {
                    scope.val = value;
                });

                scope.readonly = false;
                if (attrs.readonly) {
                    scope.$parent.$watch($parse(attrs.readonly), function(value) {
                        scope.readonly = !!value;
                    });
                }
            }
        };
    }]);

/**
 * @ngdoc overview
 * @name ui.bootstrap.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */

angular.module('ui.bootstrap.tabs', [])

    .directive('tabs', function() {
        return function() {
            throw new Error("The `tabs` directive is deprecated, please migrate to `tabset`. Instructions can be found at http://github.com/angular-ui/bootstrap/tree/master/CHANGELOG.md");
        };
    })

    .controller('TabsetController', ['$scope', '$element',
        function TabsetCtrl($scope, $element) {

            var ctrl = this,
                tabs = ctrl.tabs = $scope.tabs = [];

            ctrl.select = function(tab) {
                angular.forEach(tabs, function(tab) {
                    tab.active = false;
                });
                tab.active = true;
            };

            ctrl.addTab = function addTab(tab) {
                tabs.push(tab);
                if (tabs.length === 1 || tab.active) {
                    ctrl.select(tab);
                }
            };

            ctrl.removeTab = function removeTab(tab) {
                var index = tabs.indexOf(tab);
                //Select a new tab if the tab to be removed is selected
                if (tab.active && tabs.length > 1) {
                    //If this is the last tab, select the previous tab. else, the next tab.
                    var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
                    ctrl.select(tabs[newActiveIndex]);
                }
                tabs.splice(index, 1);
            };
        }])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {string=} direction  What direction the tabs should be rendered. Available:
 * 'right', 'left', 'below'.
 *
 * @example
 <example module="ui.bootstrap">
 <file name="index.html">
 <tabset>
 <tab heading="Vertical Tab 1"><b>First</b> Content!</tab>
 <tab heading="Vertical Tab 2"><i>Second</i> Content!</tab>
 </tabset>
 <hr />
 <tabset vertical="true">
 <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
 <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
 </tabset>
 </file>
 </example>
 */
    .directive('tabset', function() {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            require: '^?tabset',
            scope: {},
            controller: 'TabsetController',
            templateUrl: 'template/tabs/tabset.html',
            compile: function(elm, attrs, transclude) {
                return function(scope, element, attrs, tabsetCtrl) {
                    // see https://cloudmon.atlassian.net/browse/GEA-270
                    if(!tabsetCtrl){
                        return;
                    }
                    scope.vertical = angular.isDefined(attrs.vertical) ? scope.$eval(attrs.vertical) : false;
                    scope.type = angular.isDefined(attrs.type) ? scope.$parent.$eval(attrs.type) : 'tabs';
                    scope.direction = angular.isDefined(attrs.direction) ? scope.$parent.$eval(attrs.direction) : 'top';
                    scope.tabsAbove = (scope.direction != 'below');
                    tabsetCtrl.$scope = scope;
                    tabsetCtrl.$transcludeFn = transclude;
                };
            }
        };
    })

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {string=} select An expression to evaluate when the tab is selected.
 * @param {boolean=} active A binding, telling whether or not this tab is selected.
 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
 *
 * @example
 <example module="ui.bootstrap">
 <file name="index.html">
 <div ng-controller="TabsDemoCtrl">
 <button class="btn btn-small" ng-click="items[0].active = true">
 Select item 1, using active binding
 </button>
 <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
 Enable/disable item 2, using disabled binding
 </button>
 <br />
 <tabset>
 <tab heading="Tab 1">First Tab</tab>
 <tab select="alertMe()">
 <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
 Second Tab, with alert callback and html heading!
 </tab>
 <tab ng-repeat="item in items"
 heading="{{item.title}}"
 disabled="item.disabled"
 active="item.active">
 {{item.content}}
 </tab>
 </tabset>
 </div>
 </file>
 <file name="script.js">
 function TabsDemoCtrl($scope) {
      $scope.items = [
        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
      ];

      $scope.alertMe = function() {
        setTimeout(function() {
          alert("You've selected the alert tab!");
        });
      };
    };
 </file>
 </example>
 */

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 *
 * @example
 <example module="ui.bootstrap">
 <file name="index.html">
 <tabset>
 <tab>
 <tab-heading><b>HTML</b> in my titles?!</tab-heading>
 And some content, too!
 </tab>
 <tab>
 <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
 That's right.
 </tab>
 </tabset>
 </file>
 </example>
 */
    .directive('tab', ['$parse', '$http', '$templateCache', '$compile',
        function($parse, $http, $templateCache, $compile) {
            return {
                require: '^?tabset',
                restrict: 'EA',
                replace: true,
                templateUrl: 'template/tabs/tab.html',
                transclude: true,
                scope: {
                    heading: '@',
                    onSelect: '&select', //This callback is called in contentHeadingTransclude
                    //once it inserts the tab's content into the dom
                    onDeselect: '&deselect'
                },
                controller: function() {
                    //Empty controller so other directives can require being 'under' a tab
                },
                compile: function(elm, attrs, transclude) {
                    return function postLink(scope, elm, attrs, tabsetCtrl) {
                        // see https://cloudmon.atlassian.net/browse/GEA-270
                        if(!tabsetCtrl){
                            return;
                        }
                        // showif feature by farmnet fip
                        if(attrs.showIf){
                            attrs.$observe( "showIf", function ( val ) {
                                scope.$parent.$watch(val,function(v){
                                    scope.showIf=v;
                                });
                            });
                        }else{
                            scope.showIf = "true";
                        }
                        var getActive, setActive;
                        if (attrs.active) {
                            getActive = $parse(attrs.active);
                            setActive = getActive.assign;
                            scope.$parent.$watch(getActive, function updateActive(value) {
                                scope.active = !!value;
                            });
                            scope.active = getActive(scope.$parent);
                        } else {
                            setActive = getActive = angular.noop;
                        }

                        scope.$watch('active', function(active) {
                            setActive(scope.$parent, active);
                            if (active) {
                                tabsetCtrl.select(scope);
                                scope.onSelect();
                            } else {
                                scope.onDeselect();
                            }
                        });

                        scope.disabled = false;
                        if ( attrs.disabled ) {
                            scope.$parent.$watch($parse(attrs.disabled), function(value) {
                                scope.disabled = !! value;
                            });
                        }

                        scope.select = function() {
                            if ( ! scope.disabled ) {
                                scope.active = true;
                            }
                        };

                        tabsetCtrl.addTab(scope);
                        scope.$on('$destroy', function() {
                            tabsetCtrl.removeTab(scope);
                        });
                        if (scope.active) {
                            setActive(scope.$parent, true);
                        }


                        //We need to transclude later, once the content container is ready.
                        //when this link happens, we're inside a tab heading.
                        scope.$transcludeFn = transclude;
                    };
                }
            };
        }])

    .directive('tabHeadingTransclude', [function() {
        return {
            restrict: 'A',
            require: '^tab',
            link: function(scope, elm, attrs, tabCtrl,$compile) {
                scope.$watch('headingElement', function updateHeadingElement(heading) {
                    if (heading) {
                        elm.html('');
                        if (typeof heading == 'function') {
                            elm.append($compile(heading)(scope));
                        } else {
                            elm.append($("<span ng-show=\"showIf\"></span>").append(heading));
                        }
                    }
                });
            }
        };
    }])

    .directive('tabContentTransclude', ['$compile', '$parse', function($compile, $parse) {
        return {
            restrict: 'A',
            require: '^?tabset',
            link: function(scope, elm, attrs) {
                var tab = scope.$eval(attrs.tabContentTransclude);

                //Now our tab is ready to be transcluded: both the tab heading area
                //and the tab content area are loaded.  Transclude 'em both.
                tab.$transcludeFn(tab.$parent, function(contents) {
                    angular.forEach(contents, function(node) {
                        if (isTabHeading(node)) {
                            console.debug("Hier, found",node,tab);
                            //Let tabHeadingTransclude know.
                            tab.headingElement = node;
                        } else {
                            elm.append(node);
                        }
                    });
                });
            }
        };
        function isTabHeading(node) {
            return node.tagName &&  (
                    node.hasAttribute('tab-heading') ||
                    node.hasAttribute('data-tab-heading') ||
                    node.tagName.toLowerCase() === 'tab-heading' ||
                    node.tagName.toLowerCase() === 'data-tab-heading'
                );
        }
    }])

    .directive('tabsetTitles', function() {
        return {
            restrict: 'A',
            require: '^?tabset',
            templateUrl: 'template/tabs/tabset-titles.html',
            replace: true,
            link: function(scope, elm, attrs, tabsetCtrl) {
                // see https://cloudmon.atlassian.net/browse/GEA-270
                if(!tabsetCtrl){
                    return;
                }
                if (!scope.$eval(attrs.tabsetTitles)) {
                    elm.remove();
                } else {
                    //now that tabs location has been decided, transclude the tab titles in
                    setTimeout(function(){ // fix for nested bug. stackoverflow suggested it...

                        // fix for nestedbug without css hack... actually correct the order here.

                        elm.insertBefore(elm.closest(".tabbable").find(".tab-content"));
                        tabsetCtrl.$transcludeFn(tabsetCtrl.$scope.$parent, function(node) {
                            elm.append(node);
                        });
                        scope.$apply();
                    },0);
                }
            }
        };
    })

;


angular.module('ui.bootstrap.timepicker', [])

    .filter('pad', function() {
        return function(input) {
            if ( angular.isDefined(input) && input.toString().length < 2 ) {
                input = '0' + input;
            }
            return input;
        };
    })

    .constant('timepickerConfig', {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        meridians: ['AM', 'PM'],
        readonlyInput: false,
        mousewheel: true
    })

    .directive('timepicker', ['padFilter', '$parse', 'timepickerConfig', function (padFilter, $parse, timepickerConfig) {
        return {
            restrict: 'EA',
            require:'ngModel',
            replace: true,
            templateUrl: 'template/timepicker/timepicker.html',
            scope: {
                model: '=ngModel'
            },
            link: function(scope, element, attrs, ngModelCtrl) {
                var selected = new Date(), meridians = timepickerConfig.meridians;

                var hourStep = timepickerConfig.hourStep;
                if (attrs.hourStep) {
                    scope.$parent.$watch($parse(attrs.hourStep), function(value) {
                        hourStep = parseInt(value, 10);
                    });
                }

                var minuteStep = timepickerConfig.minuteStep;
                if (attrs.minuteStep) {
                    scope.$parent.$watch($parse(attrs.minuteStep), function(value) {
                        minuteStep = parseInt(value, 10);
                    });
                }

                // 12H / 24H mode
                scope.showMeridian = timepickerConfig.showMeridian;
                if (attrs.showMeridian) {
                    scope.$parent.$watch($parse(attrs.showMeridian), function(value) {
                        scope.showMeridian = !! value;

                        if ( ! scope.model ) {
                            // Reset
                            var dt = new Date( selected );
                            var hours = getScopeHours();
                            if (angular.isDefined( hours )) {
                                dt.setHours( hours );
                            }
                            scope.model = new Date( dt );
                        } else {
                            refreshTemplate();
                        }
                    });
                }

                // Get scope.hours in 24H mode if valid
                function getScopeHours ( ) {
                    var hours = parseInt( scope.hours, 10 );
                    var valid = ( scope.showMeridian ) ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
                    if ( !valid ) {
                        return;
                    }

                    if ( scope.showMeridian ) {
                        if ( hours === 12 ) {
                            hours = 0;
                        }
                        if ( scope.meridian === meridians[1] ) {
                            hours = hours + 12;
                        }
                    }
                    return hours;
                }

                // Input elements
                var inputs = element.find('input');
                var hoursInputEl = inputs.eq(0), minutesInputEl = inputs.eq(1);

                // Respond on mousewheel spin
                var mousewheel = (angular.isDefined(attrs.mousewheel)) ? scope.$eval(attrs.mousewheel) : timepickerConfig.mousewheel;
                if ( mousewheel ) {

                    var isScrollingUp = function(e) {
                        if (e.originalEvent) {
                            e = e.originalEvent;
                        }
                        //pick correct delta variable depending on event
                        var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
                        return (e.detail || delta > 0);
                    };

                    hoursInputEl.bind('mousewheel wheel', function(e) {
                        scope.$apply( (isScrollingUp(e)) ? scope.incrementHours() : scope.decrementHours() );
                        e.preventDefault();
                    });

                    minutesInputEl.bind('mousewheel wheel', function(e) {
                        scope.$apply( (isScrollingUp(e)) ? scope.incrementMinutes() : scope.decrementMinutes() );
                        e.preventDefault();
                    });
                }

                var keyboardChange = false;
                scope.readonlyInput = (angular.isDefined(attrs.readonlyInput)) ? scope.$eval(attrs.readonlyInput) : timepickerConfig.readonlyInput;
                if ( ! scope.readonlyInput ) {
                    scope.updateHours = function() {
                        var hours = getScopeHours();

                        if ( angular.isDefined(hours) ) {
                            keyboardChange = 'h';
                            if ( scope.model === null ) {
                                scope.model = new Date( selected );
                            }
                            scope.model.setHours( hours );
                        } else {
                            scope.model = null;
                            scope.validHours = false;
                        }
                    };

                    hoursInputEl.bind('blur', function(e) {
                        if ( scope.validHours && scope.hours < 10) {
                            scope.$apply( function() {
                                scope.hours = padFilter( scope.hours );
                            });
                        }
                    });

                    scope.updateMinutes = function() {
                        var minutes = parseInt(scope.minutes, 10);
                        if ( minutes >= 0 && minutes < 60 ) {
                            keyboardChange = 'm';
                            if ( scope.model === null ) {
                                scope.model = new Date( selected );
                            }
                            scope.model.setMinutes( minutes );
                        } else {
                            scope.model = null;
                            scope.validMinutes = false;
                        }
                    };

                    minutesInputEl.bind('blur', function(e) {
                        if ( scope.validMinutes && scope.minutes < 10 ) {
                            scope.$apply( function() {
                                scope.minutes = padFilter( scope.minutes );
                            });
                        }
                    });
                } else {
                    scope.updateHours = angular.noop;
                    scope.updateMinutes = angular.noop;
                }

                scope.$watch( function getModelTimestamp() {
                    return +scope.model;
                }, function( timestamp ) {
                    if ( !isNaN( timestamp ) && timestamp > 0 ) {
                        selected = new Date( timestamp );
                        refreshTemplate();
                    }
                });

                function refreshTemplate() {
                    var hours = selected.getHours();
                    if ( scope.showMeridian ) {
                        // Convert 24 to 12 hour system
                        hours = ( hours === 0 || hours === 12 ) ? 12 : hours % 12;
                    }
                    scope.hours =  ( keyboardChange === 'h' ) ? hours : padFilter(hours);
                    scope.validHours = true;

                    var minutes = selected.getMinutes();
                    scope.minutes = ( keyboardChange === 'm' ) ? minutes : padFilter(minutes);
                    scope.validMinutes = true;

                    scope.meridian = ( scope.showMeridian ) ? (( selected.getHours() < 12 ) ? meridians[0] : meridians[1]) : '';

                    keyboardChange = false;
                }

                function addMinutes( minutes ) {
                    var dt = new Date( selected.getTime() + minutes * 60000 );
                    selected.setHours( dt.getHours() );
                    selected.setMinutes( dt.getMinutes() );
                    scope.model = new Date( selected );
                }

                scope.incrementHours = function() {
                    addMinutes( hourStep * 60 );
                };
                scope.decrementHours = function() {
                    addMinutes( - hourStep * 60 );
                };
                scope.incrementMinutes = function() {
                    addMinutes( minuteStep );
                };
                scope.decrementMinutes = function() {
                    addMinutes( - minuteStep );
                };
                scope.toggleMeridian = function() {
                    addMinutes( 12 * 60 * (( selected.getHours() < 12 ) ? 1 : -1) );
                };
            }
        };
    }]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
    .factory('typeaheadParser', ['$parse', function ($parse) {

        //                      00000111000000000000022200000000000000003333333333333330000000000044000
        var TYPEAHEAD_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;

        return {
            parse:function (input) {

                var match = input.match(TYPEAHEAD_REGEXP), modelMapper, viewMapper, source;
                if (!match) {
                    throw new Error(
                        "Expected typeahead specification in form of '_modelValue_ (as _label_)? for _item_ in _collection_'" +
                        " but got '" + input + "'.");
                }

                return {
                    itemName:match[3],
                    source:$parse(match[4]),
                    viewMapper:$parse(match[2] || match[1]),
                    modelMapper:$parse(match[1])
                };
            }
        };
    }])

    .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$position', 'typeaheadParser', function ($compile, $parse, $q, $timeout, $document, $position, typeaheadParser) {

        var HOT_KEYS = [9, 13, 27, 38, 40];

        return {
            require:'ngModel',
            link:function (originalScope, element, attrs, modelCtrl) {

                //SUPPORTED ATTRIBUTES (OPTIONS)

                //minimal no of characters that needs to be entered before typeahead kicks-in
                var minSearch = originalScope.$eval(attrs.typeaheadMinLength) || 1;

                //minimal wait time after last character typed before typehead kicks-in
                var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

                //should it restrict model values to the ones selected from the popup only?
                var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;

                //binding to a variable that indicates if matches are being retrieved asynchronously
                var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

                //a callback executed when a match is selected
                var onSelectCallback = $parse(attrs.typeaheadOnSelect);

                var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

                //INTERNAL VARIABLES

                //model setter executed upon match selection
                var $setModelValue = $parse(attrs.ngModel).assign;

                //expressions used by typeahead
                var parserResult = typeaheadParser.parse(attrs.typeahead);


                //pop-up element used to display matches
                var popUpEl = angular.element('<typeahead-popup></typeahead-popup>');
                popUpEl.attr({
                    matches: 'matches',
                    active: 'activeIdx',
                    select: 'select(activeIdx)',
                    query: 'query',
                    position: 'position'
                });
                //custom item template
                if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
                    popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
                }

                //create a child scope for the typeahead directive so we are not polluting original scope
                //with typeahead-specific data (matches, query etc.)
                var scope = originalScope.$new();
                originalScope.$on('$destroy', function(){
                    scope.$destroy();
                });

                var resetMatches = function() {
                    scope.matches = [];
                    scope.activeIdx = -1;
                };

                var getMatchesAsync = function(inputValue) {

                    var locals = {$viewValue: inputValue};
                    isLoadingSetter(originalScope, true);
                    $q.when(parserResult.source(scope, locals)).then(function(matches) {

                        //it might happen that several async queries were in progress if a user were typing fast
                        //but we are interested only in responses that correspond to the current view value
                        if (inputValue === modelCtrl.$viewValue) {
                            if (matches.length > 0) {

                                scope.activeIdx = 0;
                                scope.matches.length = 0;

                                //transform labels
                                for(var i=0; i<matches.length; i++) {
                                    locals[parserResult.itemName] = matches[i];
                                    scope.matches.push({
                                        label: parserResult.viewMapper(scope, locals),
                                        model: matches[i]
                                    });
                                }

                                scope.query = inputValue;
                                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                                //due to other elements being rendered
                                scope.position = $position.position(element);
                                scope.position.top = scope.position.top + element.prop('offsetHeight');

                            } else {
                                resetMatches();
                            }
                            isLoadingSetter(originalScope, false);
                        }
                    }, function(){
                        resetMatches();
                        isLoadingSetter(originalScope, false);
                    });
                };

                resetMatches();

                //we need to propagate user's query so we can higlight matches
                scope.query = undefined;

                //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
                var timeoutPromise;

                //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
                //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
                modelCtrl.$parsers.push(function (inputValue) {

                    resetMatches();
                    if (inputValue && inputValue.length >= minSearch) {
                        if (waitTime > 0) {
                            if (timeoutPromise) {
                                $timeout.cancel(timeoutPromise);//cancel previous timeout
                            }
                            timeoutPromise = $timeout(function () {
                                getMatchesAsync(inputValue);
                            }, waitTime);
                        } else {
                            getMatchesAsync(inputValue);
                        }
                    }

                    return isEditable ? inputValue : undefined;
                });

                modelCtrl.$formatters.push(function (modelValue) {

                    var candidateViewValue, emptyViewValue;
                    var locals = {};

                    if (inputFormatter) {

                        locals['$model'] = modelValue;
                        return inputFormatter(originalScope, locals);

                    } else {
                        locals[parserResult.itemName] = modelValue;

                        //it might happen that we don't have enough info to properly render input value
                        //we need to check for this situation and simply return model value if we can't apply custom formatting
                        candidateViewValue = parserResult.viewMapper(originalScope, locals);
                        emptyViewValue = parserResult.viewMapper(originalScope, {});

                        return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
                    }
                });

                scope.select = function (activeIdx) {
                    //called from within the $digest() cycle
                    var locals = {};
                    var model, item;

                    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                    model = parserResult.modelMapper(originalScope, locals);
                    $setModelValue(originalScope, model);

                    onSelectCallback(originalScope, {
                        $item: item,
                        $model: model,
                        $label: parserResult.viewMapper(originalScope, locals)
                    });

                    //return focus to the input element if a mach was selected via a mouse click event
                    resetMatches();
                    element[0].focus();
                };

                //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
                element.bind('keydown', function (evt) {

                    //typeahead is open and an "interesting" key was pressed
                    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
                        return;
                    }

                    evt.preventDefault();

                    if (evt.which === 40) {
                        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                        scope.$digest();

                    } else if (evt.which === 38) {
                        scope.activeIdx = (scope.activeIdx ? scope.activeIdx : scope.matches.length) - 1;
                        scope.$digest();

                    } else if (evt.which === 13 || evt.which === 9) {
                        scope.$apply(function () {
                            scope.select(scope.activeIdx);
                        });

                    } else if (evt.which === 27) {
                        evt.stopPropagation();

                        resetMatches();
                        scope.$digest();
                    }
                });

                $document.bind('click', function(){
                    resetMatches();
                    scope.$digest();
                });

                element.after($compile(popUpEl)(scope));
            }
        };

    }])

    .directive('typeaheadPopup', function () {
        return {
            restrict:'E',
            scope:{
                matches:'=',
                query:'=',
                active:'=',
                position:'=',
                select:'&'
            },
            replace:true,
            templateUrl:'template/typeahead/typeahead-popup.html',
            link:function (scope, element, attrs) {

                scope.templateUrl = attrs.templateUrl;

                scope.isOpen = function () {
                    return scope.matches.length > 0;
                };

                scope.isActive = function (matchIdx) {
                    return scope.active == matchIdx;
                };

                scope.selectActive = function (matchIdx) {
                    scope.active = matchIdx;
                };

                scope.selectMatch = function (activeIdx) {
                    scope.select({activeIdx:activeIdx});
                };
            }
        };
    })

    .directive('typeaheadMatch', ['$http', '$templateCache', '$compile', '$parse', function ($http, $templateCache, $compile, $parse) {
        return {
            restrict:'E',
            scope:{
                index:'=',
                match:'=',
                query:'='
            },
            link:function (scope, element, attrs) {
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
                $http.get(tplUrl, {cache: $templateCache}).success(function(tplContent){
                    element.replaceWith($compile(tplContent.trim())(scope));
                });
            }
        };
    }])

    .filter('typeaheadHighlight', function() {

        function escapeRegexp(queryToEscape) {
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        }

        return function(matchItem, query) {
            return query ? matchItem.replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : query;
        };
    });
angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/accordion/accordion-group.html",
        "<div class=\"accordion-group\">\n" +
        "  <div class=\"accordion-heading\" ><a class=\"accordion-toggle\" ng-class=\"{accCollapsed : !isOpen, accExpanded: isOpen}\" data-toggle=\"collapse\" ng-click=\"isOpen = !isOpen\" accordion-transclude=\"heading\">{{heading}}</a></div>\n" +
        "  <div class=\"accordion-body\" collapse=\"!isOpen\">\n" +
        "    <div class=\"accordion-inner\" ng-transclude></div>  </div>\n" +
        "</div>");
}]);

angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/accordion/accordion.html",
        "<div class=\"accordion\" ng-transclude></div>");
}]);

angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/alert/alert.html",
        "<div class='alert' ng-class='type && \"alert-\" + type'>\n" +
        "    <button ng-show='closeable' type='button' class='close' ng-click='close()'>&times;</button>\n" +
        "    <div ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/carousel/carousel.html",
        "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\">\n" +
        "    <ol class=\"carousel-indicators\" ng-show=\"slides().length > 1\">\n" +
        "        <li ng-repeat=\"slide in slides()\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
        "    </ol>\n" +
        "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
        "    <a ng-click=\"prev()\" class=\"carousel-control left\" ng-show=\"slides().length > 1\">&lsaquo;</a>\n" +
        "    <a ng-click=\"next()\" class=\"carousel-control right\" ng-show=\"slides().length > 1\">&rsaquo;</a>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/carousel/slide.html",
        "<div ng-class=\"{\n" +
        "    'active': leaving || (active && !entering),\n" +
        "    'prev': (next || active) && direction=='prev',\n" +
        "    'next': (next || active) && direction=='next',\n" +
        "    'right': direction=='prev',\n" +
        "    'left': direction=='next'\n" +
        "  }\" class=\"item\" ng-transclude></div>\n" +
        "");
}]);

angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/datepicker/datepicker.html",
        "<table>\n" +
        "  <thead>\n" +
        "    <tr class=\"text-center\">\n" +
        "      <th><button type=\"button\" class=\"btn pull-left\" ng-click=\"move(-1)\"><i class=\"icon-chevron-left\"></i></button></th>\n" +
        "      <th colspan=\"{{rows[0].length - 2 + showWeekNumbers}}\"><button type=\"button\" class=\"btn btn-block\" ng-click=\"toggleMode()\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn pull-right\" ng-click=\"move(1)\"><i class=\"icon-chevron-right\"></i></button></th>\n" +
        "    </tr>\n" +
        "    <tr class=\"text-center\" ng-show=\"labels.length > 0\">\n" +
        "      <th ng-show=\"showWeekNumbers\">#</th>\n" +
        "      <th ng-repeat=\"label in labels\">{{label}}</th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr ng-repeat=\"row in rows\">\n" +
        "      <td ng-show=\"showWeekNumbers\" class=\"text-center\"><em>{{ getWeekNumber(row) }}</em></td>\n" +
        "      <td ng-repeat=\"dt in row\" class=\"text-center\">\n" +
        "        <button type=\"button\" style=\"width:100%;\" class=\"btn\" ng-class=\"{'btn-info': dt.selected}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\"><span ng-class=\"{muted: dt.secondary}\">{{dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/datepicker/popup.html",
        "<ul class=\"dropdown-menu\" ng-class=\"{animations: null}\" ng-style=\"{position:'fixed', display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" class=\"dropdown-menu\">\n" +
        "	<li ng-transclude ng-class=\"{animations: null}\"></li>\n" +
        //"	<li class=\"divider\"></li>\n" +
        //"	<li style=\"padding: 9px;\">\n" +
        //"		<span class=\"btn-group\">\n" +
        //"			<button class=\"btn btn-small btn-inverse\" ng-click=\"today()\">Today</button>\n" +
        //"			<button class=\"btn btn-small btn-info\" ng-click=\"showWeeks = ! showWeeks\" ng-class=\"{active: showWeeks}\">Weeks</button>\n" +
        //"			<button class=\"btn btn-small btn-danger\" ng-click=\"clear()\">Clear</button>\n" +
        //"		</span>\n" +
        //"		<button class=\"btn btn-small btn-success pull-right\" ng-click=\"isOpen = false\">Close</button>\n" +
        //"	</li>\n" +
        "</ul>");
}]);

angular.module("template/dialog/message.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/dialog/message.html",
        "<div class=\"modal-header\">\n" +
        "	<h3>{{ title }}</h3>\n" +
        "</div>\n" +
        "<div class=\"modal-body\">\n" +
        "	<p ng-bind-html=\"message\"></p>\n" +
        "</div>\n" +
        "<div class=\"modal-footer\">\n" +
        "	<button ng-repeat=\"btn in buttons\" ng-click=\"close(btn.result)\" class=\"btn\" ng-class=\"btn.cssClass\">{{ btn.label }}</button>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/modal/backdrop.html",
        "<div class=\"modal-backdrop fade in\"></div>");
}]);

angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/modal/window.html",
        "<div class=\"modal in\" ng-transclude></div>");
}]);

angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/pagination/pager.html",
        "<div class=\"pager\">\n" +
        "  <ul>\n" +
        "    <li ng-repeat=\"page in pages\" ng-class=\"{disabled: page.disabled, previous: page.previous, next: page.next}\"><a ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
        "  </ul>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/pagination/pagination.html",
        "<div class=\"pagination\"><ul>\n" +
        "  <li ng-repeat=\"page in pages\" ng-class=\"{active: page.active, disabled: page.disabled}\"><a ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
        "  </ul>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
        "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
        "  <div class=\"tooltip-arrow\"></div>\n" +
        "  <div class=\"tooltip-inner\" ng-bind-html-unsafe=\"content\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tooltip/tooltip-popup.html",
        "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
        "  <div class=\"tooltip-arrow\"></div>\n" +
        "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/popover/popover.html",
        "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
        "  <div class=\"arrow\"></div>\n" +
        "\n" +
        "  <div class=\"popover-inner\">\n" +
        "      <div class=\"popover-title\"><h3 ng-bind=\"titletext\" ng-show=\"titletext\"></h3><span class=\"extra\" ng-bind-html=\"unsafetitlelink\"></span><button ng-show=\"titletext\"  type=\"button\" class=\"close\" ng-click=\"tt_isOpen=false;\">×</button>" +
        "      <div class=\"clearfix\"></div> </div>\n" +
        "      <div class=\"popover-content\" ><ng-include src=\"content\"></ng-include></div>\n" +
        "  </div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/progressbar/bar.html",
        "<div class=\"bar\" ng-class='type && \"bar-\" + type'></div>");
}]);

angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/progressbar/progress.html",
        "<div class=\"progress\"><progressbar ng-repeat=\"bar in bars\" width=\"bar.to\" old=\"bar.from\" animate=\"bar.animate\" type=\"bar.type\"></progressbar></div>");
}]);

angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/rating/rating.html",
        "<span ng-mouseleave=\"reset()\">\n" +
        "	<i ng-repeat=\"number in range\" ng-mouseenter=\"enter(number)\" ng-click=\"rate(number)\" ng-class=\"{'icon-star': number <= val, 'icon-star-empty': number > val}\"></i>\n" +
        "</span>");
}]);

angular.module("template/tabs/pane.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tabs/pane.html",
        "<div class=\"tab-pane\" ng-class=\"{active: selected}\" ng-show=\"selected\" ng-transclude></div>\n" +
        "");
}]);

angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tabs/tab.html",
        "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
        "  <a ng-click=\"select()\" ng-show=\"showIf\" tab-heading-transclude>{{heading}}</a>\n" +
        "</li>\n" +
        "");
}]);

angular.module("template/tabs/tabs.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tabs/tabs.html",
        "<div class=\"tabbable\">\n" +
        "  <ul class=\"nav nav-tabs\">\n" +
        "    <li ng-repeat=\"pane in panes\" ng-class=\"{active:pane.selected}\">\n" +
        "      <a ng-click=\"select(pane)\">{{pane.heading}}</a>\n" +
        "    </li>\n" +
        "  </ul>\n" +
        "  <div class=\"tab-content\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/tabs/tabset-titles.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tabs/tabset-titles.html",
        "<ul class=\"nav {{type && 'nav-' + type}}\" ng-class=\"{'nav-stacked': vertical}\">\n" +
        "</ul>\n" +
        "");
}]);

angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/tabs/tabset.html",
        "\n" +
        "<div class=\"tabbable\" ng-class=\"{'tabs-right': direction == 'right', 'tabs-left': direction == 'left', 'tabs-below': direction == 'below'}\">\n" +
        "  <div tabset-titles=\"tabsAbove\"></div>\n" +
        "  <div class=\"tab-content\">\n" +
        "    <div class=\"tab-pane\" \n" +
        "         ng-repeat=\"tab in tabs\" \n" +
        "         ng-class=\"{active: tab.active}\"\n" +
        "         tab-content-transclude=\"tab\">\n" +
        "    </div>\n" +
        "  </div>\n" +
        "  <div tabset-titles=\"!tabsAbove\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/timepicker/timepicker.html",
        "<table class=\"form-inline\">\n" +
        "	<tr class=\"text-center\">\n" +
        "		<td><a ng-click=\"incrementHours()\" class=\"btn btn-link\"><i class=\"icon-chevron-up\"></i></a></td>\n" +
        "		<td>&nbsp;</td>\n" +
        "		<td><a ng-click=\"incrementMinutes()\" class=\"btn btn-link\"><i class=\"icon-chevron-up\"></i></a></td>\n" +
        "		<td ng-show=\"showMeridian\"></td>\n" +
        "	</tr>\n" +
        "	<tr>\n" +
        "		<td class=\"control-group\" ng-class=\"{'error': !validHours}\"><input type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"span1 text-center\" ng-mousewheel=\"incrementHours()\" ng-readonly=\"readonlyInput\" maxlength=\"2\" /></td>\n" +
        "		<td>:</td>\n" +
        "		<td class=\"control-group\" ng-class=\"{'error': !validMinutes}\"><input type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"span1 text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\"></td>\n" +
        "		<td ng-show=\"showMeridian\"><button ng-click=\"toggleMeridian()\" class=\"btn text-center\">{{meridian}}</button></td>\n" +
        "	</tr>\n" +
        "	<tr class=\"text-center\">\n" +
        "		<td><a ng-click=\"decrementHours()\" class=\"btn btn-link\"><i class=\"icon-chevron-down\"></i></a></td>\n" +
        "		<td>&nbsp;</td>\n" +
        "		<td><a ng-click=\"decrementMinutes()\" class=\"btn btn-link\"><i class=\"icon-chevron-down\"></i></a></td>\n" +
        "		<td ng-show=\"showMeridian\"></td>\n" +
        "	</tr>\n" +
        "</table>");
}]);

angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/typeahead/typeahead-match.html",
        "<a tabindex=\"-1\" ng-bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");
}]);

angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/typeahead/typeahead-popup.html",
        "<ul class=\"typeahead dropdown-menu\" ng-style=\"{display: isOpen()&&'block' || 'none', top: position.top+'px', left: position.left+'px'}\">\n" +
        "    <li ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\">\n" +
        "        <typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></typeahead-match>\n" +
        "    </li>\n" +
        "</ul>");
}]);

angular.module("template/typeahead/typeahead.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put("template/typeahead/typeahead.html",
        "<ul class=\"typeahead dropdown-menu\" ng-style=\"{display: isOpen()&&'block' || 'none', top: position.top+'px', left: position.left+'px'}\">\n" +
        "    <li ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\">\n" +
        "        <a tabindex=\"-1\" ng-click=\"selectMatch($index)\" ng-bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>\n" +
        "    </li>\n" +
        "</ul>");
}]);
